import { DisciplineEnum } from './../../_shared/models/csTypes/enums/discipline';
import { PickleballTrackerBrainService } from './services/pickleball/pickleball-tracker-brain.service';
import { BadmintonTrackerBrainService } from './services/badminton/badminton-tracker-brain.service';
import { TableTennisTrackerBrainService } from './services/table-tennis/table-tennis-tracker-brain.service';
import { SquashTrackerBrainService } from './services/squash/squash-tracker-brain.service';
import { SquashGameType } from '../../_shared/models/enums/squash.enum';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { LoadingController, ModalController, Platform } from '@ionic/angular';
import { Socket } from 'ngx-socket-io';
import { MatchService } from '../../_core/services/match.service';
import { Game, GameFormat } from '../../_shared/models/game.model';
import { IPlayerCourtTimeLog, Match, ScheduledItem } from '../../_shared/models/match.model';
import {
  PlayerCourtPosition,
  PlayerInfo,
  PlayerPosition,
  Point,
  Server,
  Timeout
} from '../../_shared/models/point.model';
import {
  ScoreFormat,
  SetType,
  TimedPointsOrGames,
} from '../../_shared/models/score-format.model';
import { Set } from '../../_shared/models/set.model';
import { BoardHelpService } from './board-help.service';
import { ServerService } from './services/server.service';
import { ScoreService } from './services/score.service';

import {
  catchError,
  debounce,
  debounceTime,
  finalize,
  map,
  mergeMap,
  switchMap,
  takeUntil,
  tap,
} from 'rxjs/operators';
import { EMPTY, firstValueFrom, of, Subject, Subscription, timer } from 'rxjs';
import { TeamHelperService } from '../../my-teams/team-helper.service';
import { MatchUpStatusEnum } from '../../_shared/models/csTypes/enums/matchup_status';
import { DownloadMatchService } from '../../scoreboard/download-match/download-match.service';
import { Tie } from '../../_shared/models/tie.model';
import { TieDetailsService } from '../../ties/tie-details/tie-details.service';

import { WinReasonEnum } from '../../_shared/models/csTypes/enums/win_reason';
import { ShotOutcomeEnum } from '../../_shared/models/csTypes/enums/shot_outcome';
import { intervalToDuration } from 'date-fns';
import { Preferences } from '@capacitor/preferences';
import { toSignal } from '@angular/core/rxjs-interop';
import { CourtSide } from '../../_shared/models/enums/court-side';
import { StopwatchComponent } from '../../_shared/components/stopwatch/stopwatch.component';
import { ClocksService } from '../../clocks/clocks.service';
import { User } from '../../_shared/models/user.model';
import { AuthService } from '../../auth/auth.service';
import { Participant } from '../../_shared/models/participant.model';
import { Router } from '@angular/router';
import { DeviceMetaService } from '../../_shared/services/device-meta.service';
import { DeviceMeta } from '../../_shared/models/point.model';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../_core/services/toast.service';
import { OfficialViewService } from '../../official-view/official-view.service';

class Notification {
  title: string;
  body: string;
}

type SubImpactStat = {
  inPlayerId: string;
  outPlayerId: string;
  sideNumber: number;
  pointsWon: number;
  pointsLost: number;
  plusMinus: number;
  pointsAnalyzed: number;
  firstPointNumber: number;
  substitutionTime: Date;
};

export interface UpdateScoreOptions {
  isUndo: boolean;
  isTimeoutStart?: boolean;
  isTimeoutEnd?: boolean;
  isTimeoutUndo?: boolean;
  isSubstituteStart?: boolean;
  isSubstituteEnd?: boolean;
  isSubstituteUndo?: boolean;
  isStartPoint?: boolean;
  isEndPoint?: boolean;
  actionSide?: number;
  isBreakEnd?: boolean;
  isBreakStart?: boolean;
  isBreakUndo?: boolean
}

@Component({
  standalone: false,
  selector: 'app-tracker-board',
  templateUrl: './tracker-board.component.html',
  styleUrls: ['./tracker-board.component.scss'],
})
export class TrackerBoardComponent implements OnInit, OnDestroy {
  private matchService = inject(MatchService);
  private socket = inject(Socket);
  private platform = inject(Platform);
  public bhs = inject(BoardHelpService);
  public ths = inject(TeamHelperService);
  private scoreService = inject(ScoreService);
  private serverService = inject(ServerService);
  private loadingController = inject(LoadingController);
  private downloadMatchService = inject(DownloadMatchService);
  private tieDetailsService = inject(TieDetailsService);
  private pickleballTrackerBrainService = inject(PickleballTrackerBrainService);
  private badmintonTrackerBrainService = inject(BadmintonTrackerBrainService);
  private tableTennisTrackerBrainService = inject(TableTennisTrackerBrainService);
  private squashTrackerBrainService = inject(SquashTrackerBrainService);
  private clocksService = inject(ClocksService);
  private authService = inject(AuthService);
  private deviceMetaService = inject(DeviceMetaService);
  private translateService = inject(TranslateService);
  private toastService = inject(ToastService);
  public officialViewService = inject(OfficialViewService);

  @Input() match!: Match;
  @Input() header: any;
  @Input() segmentToolbar: any;
  @Input() trackServeLocation = true;
  @Input() shotStatsBoard = true;
  @Output() updatedMatch = new EventEmitter();
  @Input() intennseView = false;

  isStatsBoard = false;
  switchedServeButton = false;
  screenHeight: number;
  scoreFormat = new ScoreFormat();
  tie: Tie;

  previousServingSide: number;
  notification: Notification;
  isBoardDisabled: boolean;

  private readonly destroy$: Subject<void> = new Subject();
  isGameAdded: boolean;

  updateScore$ = new Subject<{ updateScoreOption: UpdateScoreOptions }>();
  cancelUpdateScore$ = new Subject();
  addedPointValue: number = 1;
  private isIntennseOfficialView: boolean = false;
  private tieUpdate$ = new Subject<void>();
  deviceMeta: DeviceMeta;
  trackerSelectedScoringType: string = null;
  isMatchFinishedInitiated: boolean = false;


  udpatedMatch$ = this.updateScore$.pipe(
    takeUntil(this.destroy$ || this.cancelUpdateScore$),
    tap(() => {
      // Devices sometimes lose socket connection. In that case connect to socket again
      if (!this.socket.ioSocket.connected) {
        this.socket.connect();
      }
    }),
    mergeMap(async ({ updateScoreOption }) => {
      this.match.score = this.scoreService.getScoreObject(this.match);
      this.matchService.publishScoreUpdated(this.match);

      const lastPoint: any = this.bhs.getLastPoint(this.match);
      const lastGame: any = this.bhs.getLastGame(this.match);

      // Ensure that point is added on UI before assigning returning side
      // If it is score format with no ads and it is deuce then ask user to select returning side
      if (
        lastPoint.server?.sideNumber &&
        this.match.discipline !== DisciplineEnum.PICKLEBALL &&
        this.match.discipline !== DisciplineEnum.BADMINTON &&
        this.match.discipline !== DisciplineEnum.TABLE_TENNIS && 
        this.match.discipline !== DisciplineEnum.SQUASH
      ) {
        this.scoreFormat = this.bhs.getScoreFormat(
          this.match.matchFormat,
          this.match.discipline,
          this.match?.score
        );
        if (this.scoreFormat.setType !== SetType.TIMED) {
          lastPoint.server.returningSide =
            !this.scoreFormat.ads &&
              lastPoint.pointNumber === 7 &&
              lastGame.gameFormat !== GameFormat.TIEBREAK
              ? await this.bhs.chooseReturningSide()
              : this.bhs.getReturningSide(lastPoint.pointNumber, this.match, this.scoreFormat);
        }

        // TODO: Commented out for now as it is not working as expected, expected ticket is in progress IOCINIT-568
        // this.toggleScoringOnTieBreakGameFormate(lastGame);
        /**
         * Publish a score update notification when the returning side is changed via the UI.
         */
        if(updateScoreOption.isSubstituteEnd){
          this.match.isIgnoreUpdate = true;
          this.matchService.publishScoreUpdated(this.match);
        }
      }
      this.deviceMeta = await this.deviceMetaService.getDeviceMeta();
      lastPoint.deviceMeta = this.deviceMeta;
      // Store match in local storage
      this.match.updatedAt = new Date().toISOString();
      await Preferences.set({
        key: this.match._id,
        value: JSON.stringify(this.match),
      });
      this.bhs.updateBoltEndStatus(false);

      if (this.match.discipline === DisciplineEnum.PICKLEBALL || this.match.discipline === DisciplineEnum.BADMINTON) {
        this.matchService.publishScoreUpdated(this.match);
      }

      return { updateScoreOption };
    }),
    debounce(({ updateScoreOption }) => {
      // the update score is for start point or end point
      // then we dont need to debounce the update
      // otherwise we need to debounce the update
      const shouldDebounce =
        !updateScoreOption.isStartPoint &&
        !updateScoreOption.isEndPoint;

      const debounceTimeMs = shouldDebounce
        ? (this.match?.scoreDelay * 1000 || 1000)
        : 500;

      return timer(debounceTimeMs);
    }),
    switchMap(({ updateScoreOption }) => {
      // this.toggleScoringOnTieBreakGameFormate(this.match);
      const updateScorePayload = {
        matchId: this.match._id,
        sets: this.match.sets,
        score: this.match.score,
        playerCourtTimeLog: this.match.playerCourtTimeLog,
        substituteTrack: this.match.substituteTrack,
        isUndo: updateScoreOption.isUndo,
        ...(updateScoreOption.isEndPoint ? { tieScore: this.match.tieScore } : {}),
        eventFlags: {
          isTimeoutStart: updateScoreOption.isTimeoutStart,
          isTimeoutEnd: updateScoreOption.isTimeoutEnd,
          isSubstituteStart: updateScoreOption.isSubstituteStart,
          isSubstituteEnd: updateScoreOption.isSubstituteEnd,
          isSubstituteUndo: updateScoreOption.isSubstituteUndo,
          isTimeoutUndo: updateScoreOption.isTimeoutUndo,
          isStartPoint: updateScoreOption.isStartPoint,
          isEndPoint: updateScoreOption.isEndPoint,
          isBreakEnd: updateScoreOption.isBreakEnd,
          isBreakStart: updateScoreOption.isBreakStart,
          isBreakUndo: updateScoreOption.isBreakUndo
        }
      };
      return this.matchService.updateScore(updateScorePayload).pipe(
        map((match) => {
          // ✅ Move logic here — only runs when updateScore succeeds
          this.trackerSelectedScoringType = null;
          return { match, updateScoreOption };
        }),
        catchError(() => {
          this.trackerSelectedScoringType = null;
          // If a user does not have tracking privileges
          // remove tracking options on match-tracker and scoreboard components
          this.updatedMatch.emit({ isTracker: false });
          return EMPTY;
        })
      );
    }),

    tap(({ match, updateScoreOption }) => {
      // Update tie score after every game if team match is using aggregated value
      // Example would be WTT    

      // Incase of UndoSubstitute, we need to relay on server response for player
      if (updateScoreOption.isSubstituteUndo) {
        this.match = { ...match.data };
        this.match.isIgnoreUpdate = true;
        this.matchService.publishScoreUpdated(this.match);
      }

      // for below action, we dont need to update tie status
      if (updateScoreOption.isSubstituteEnd || updateScoreOption.isTimeoutEnd || updateScoreOption.isSubstituteStart || updateScoreOption.isTimeoutUndo || updateScoreOption.isTimeoutStart || updateScoreOption.isSubstituteUndo) {
        return;
      }
      if (localStorage.getItem('match-tracker-stats') && updateScoreOption.isEndPoint) {
        const playerStat = this.initializePlayerStats(match.data)
        this.calculateServeStats(match.data, playerStat)
      }

      const shouldTieUpdate = this.match.tie && ((this.tie?.tieFormat?.winCriteria.aggregateValue && this.isGameAdded) || this.scoreFormat.timedPointsOrGames);

      if (shouldTieUpdate) {
        if (updateScoreOption.isStartPoint || updateScoreOption.isEndPoint) {
          this.tieUpdate$.next();
        } else {
          this.tieDetailsService.tieStatusUpdate(this.isSendNotification());
          this.isGameAdded = false;
        }
      }
    })
  );

  updatedScoreMatch = toSignal(this.udpatedMatch$);

  private playerServerUpdateSubscription = new Subscription();
  private scoringTypeSubscription = new Subscription();

  constructor(private router: Router) { }

  async ngOnInit() {
    this.screenHeight =
      this.platform.height() - this.header - this.segmentToolbar;
    if (await this.scoreService.checkIfLocalScoreIsNewer(this.match))
      await this.updateMatch(false);
    this.scoreFormat = this.bhs.getScoreFormat(
      this.match.matchFormat,
      this.match.discipline,
      this.match?.score
    );

    if (this.match.tie) {
      this.tie = await this.tieDetailsService.getTieInfo(
        this.match.tie,
        false,
        false,
        'tracker board ln 83'
      );
    }
    this.subscriptions();

    if (this.router.url.includes('/intennse-official-view')) {
      this.isIntennseOfficialView = true
    }

    this.tieUpdate$
      .pipe(debounceTime(1000)) // only call after 1s of silence
      .subscribe(() => {
        this.tieDetailsService.tieStatusUpdate(this.isSendNotification());
        this.isGameAdded = false;
      });
      this.subscribeTrackerChangedScoringType();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.playerServerUpdateSubscription.unsubscribe();
    this.scoringTypeSubscription.unsubscribe();
  }

  private async addSet(sideNumber: number) {
    let setsPlayer1 = 0;
    let setsPlayer2 = 0;

    const lastSet = this.bhs.getLastSet(this.match);
    lastSet.winningSide = sideNumber;
    lastSet.isCompleted = true;
    lastSet.timestamp = new Date();

    this.match.sets.forEach((set) => {
      set.winningSide === 1 ? setsPlayer1++ : setsPlayer2++;
    });

    if (
      !this.scoreFormat.timedPointsOrGames &&
      (setsPlayer1 === this.scoreFormat.numberOfSetsToWin ||
        setsPlayer2 === this.scoreFormat.numberOfSetsToWin)
    ) {
      this.finishMatch(sideNumber);
    } else if (
      this.scoreFormat.timedPointsOrGames &&
      this.scoreFormat.numberOfSets === this.match.sets.length
    ) {
      this.finishMatch(sideNumber);
    } else {
      this.notification = {
        title: `${this.bhs.getPlayersNames(
          this.match,
          sideNumber
        )}. has won set`,
        body: `${this.bhs.getPlayersNames(
          this.match,
          1
        )}. - ${this.bhs.getPlayersNames(
          this.match,
          2
        )}. ${this.scoreService.getCurrentMatchScoreString(this.match)}`,
      };
      await this.startNewSet();
    }
  }

  async completeTimedSet() {
    let sideNumber: number | undefined;
    let setSideNumber: number | undefined;
    this.bhs.updateBoltEndStatus(true)
    // when bolt end, we need to set the timestamp of the last point
    // this for handling to deduct bolt time from players
    const lastPoint = this.bhs.getLastPoint(this.match);
    if (lastPoint) {
      lastPoint.timestamp = new Date();
    }
    if (this.scoreFormat.timedPointsOrGames === TimedPointsOrGames.POINT) {
      const nextToLastPoint = this.bhs.getNextToLastPoint(this.match);
      const lastSet = this.bhs.getLastSet(this.match);
      const side1Score = Number(lastSet?.side1Score);
      const side2Score = Number(lastSet?.side2Score);
      if (side1Score > side2Score) setSideNumber = 1;
      else if (side2Score > side1Score) setSideNumber = 2;
      lastSet.winningSide = setSideNumber;
      lastSet.isCompleted = true;
      lastSet.timestamp = new Date();

      if (this.match.sets.length === this.scoreFormat.numberOfSets) {
        const side1PointScore = Number(this.match?.score?.side1PointScore);
        const side2PointScore = Number(this.match?.score?.side2PointScore);
        if (side1PointScore === side2PointScore) {
          alert('The match cannot finish as a tie');
          return;
        } else if (side1PointScore > side2PointScore) sideNumber = 1;
        else if (side2PointScore > side1PointScore) sideNumber = 2;
        this.finishMatch(sideNumber);
      } else {
        const side1Score = Number(nextToLastPoint.side1Score);
        const side2Score = Number(nextToLastPoint.side2Score);
        if (side1Score > side2Score) sideNumber = 1;
        else if (side2Score > side1Score) sideNumber = 2;
        this.addGame(sideNumber);
      }

      this.scoreService.endBoltMatch(true)

    } else {
      const lastSet = this.bhs.getLastSet(this.match);
      if (Number(lastSet.side1Score) > Number(lastSet.side2Score))
        sideNumber = 1;
      else if (Number(lastSet.side2Score) > Number(lastSet.side1Score))
        sideNumber = 2;
      lastSet.games?.splice(-1);
      lastSet.winningSide = sideNumber;
      lastSet.isCompleted = true;
      lastSet.timestamp = new Date();

      if (this.match.sets.length === this.scoreFormat.numberOfSets) {
        this.finishMatch(sideNumber);
      } else {
        await this.startNewSet();
      }
    }
  }

  async startNewSet() {
    const currentSetNumber = this.bhs.getLastSet(this.match).setNumber;
    const lastSet = this.bhs.getLastSet(this.match);
    this.match.sets.push(new Set());
    this.bhs.getLastSet(this.match).setNumber = currentSetNumber + 1;
    this.bhs.getLastSet(this.match).previousScoringType = this.getPreviousScoringType(lastSet);
    this.bhs.getLastSet(this.match).games.push(new Game());
    this.bhs.getLastGame(this.match).gameNumber = 1;

    if (
      (this.bhs.isFinalSet(this.match) && this.scoreFormat.lastSet !== 'WB2') ||
      this.scoreFormat.setType === SetType.TIEBREAK
    ) {
      this.bhs.getLastGame(this.match).gameFormat = GameFormat.TIEBREAK;
    }
    let isTiebreak = this.bhs.getLastGame(this.match).gameFormat === GameFormat.TIEBREAK? true : false;
    this.bhs.getLastGame(this.match).currentScoringType = this.getCurrentScoringType(this.match, isTiebreak);
    this.startNewPoint(true);
  }

  private finishMatch(sideNumber: number) {    
    this.isMatchFinishedInitiated = true;
    this.match.score = this.scoreService.getScoreObject(this.match);

    this.cancelUpdateScore$.next(true);
    const scheduledItemObj: ScheduledItem = {
      itemType: 'endTime',
      itemSubject: 'MATCHUP',
    };

    this.matchService
      .addScheduledItem(scheduledItemObj, this.match._id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: async () => {
          this.notification = {
            title: `${this.bhs.getPlayersNames(
              this.match,
              sideNumber
            )} won the match.`,
            body: `${this.bhs.getPlayersNames(
              this.match,
              1
            )} - ${this.bhs.getPlayersNames(
              this.match,
              2
            )}. ${this.scoreService.getCurrentMatchScoreString(this.match)}`,
          };

          this.match = {
            ...this.match,
            ...{
              winningSide: sideNumber,
              matchStatus: MatchUpStatusEnum.COMPLETED,
              endDate: new Date(),
            },
          };

          const playerCourtTimeLog = this.match.playerCourtTimeLog;
          if (playerCourtTimeLog && playerCourtTimeLog['side1'] && playerCourtTimeLog['side2']) {
            // Update outTime for all players
            const currentTime = new Date().toISOString();
            for (const side of ['side1', 'side2']) {
              playerCourtTimeLog[side].forEach(playerEntry => {
                if (playerEntry.inTime && !playerEntry.outTime && !playerEntry.substitutedBy) {
                  playerEntry.outTime = currentTime;
                }
                return playerEntry;
              });
            }
            this.match = {
              ...this.match,
              playerCourtTimeLog: playerCourtTimeLog,
            }
          }

          this.matchService.publishScoreUpdated(this.match);
          this.updateMatch(false);
          
        },
        error: () => {
          this.isMatchFinishedInitiated = false;
        }
      });
  }

  async addGame(sideNumber: number, winReason?: WinReasonEnum) {
    if(this.isMatchFinishedInitiated) return
    this.isGameAdded = true;
    const lastGame: any = this.bhs.getLastGame(this.match);
    const lastPoint: any = this.bhs.getLastPoint(this.match);
    lastPoint.scoreSubmittedBy = this.authService.authUserSignal()?._id;
    lastGame.winningSide = sideNumber;

    let gameWinnerNextToLastGameScore = 0;
    let gameLoserNextToLastGameScore = 0;

    if (
      this.bhs.getNextToLastGame(this.match) &&
      this.bhs.getLastSet(this.match).games!.length > 1
    ) {
      gameWinnerNextToLastGameScore =
        sideNumber === 1
          ? this.bhs.getNextToLastGame(this.match).side1Score
          : this.bhs.getNextToLastGame(this.match).side2Score;
      gameLoserNextToLastGameScore =
        sideNumber === 1
          ? this.bhs.getNextToLastGame(this.match).side2Score
          : this.bhs.getNextToLastGame(this.match).side1Score;
    }

    let setIsFinished = false;
    let isTiebreak = false;

    lastGame.timestamp = new Date();

    if (this.bhs.getLastSet(this.match).games.length < 2) {
      // In these siuations we have only 1 game in the set. If game is added the set is finished
      // All pickleball matches
      // All badminton matches
      // All table tennis matches (each set consists of only one game)
      // All timed matches that are point based
      // When the last set is different and it is not is not win by 2 (basically it's tiebreak)
      // If a game format is tiebreak finish the set

      if (
        this.match.discipline === DisciplineEnum.PICKLEBALL ||
        this.match.discipline === DisciplineEnum.BADMINTON ||
        this.match.discipline === DisciplineEnum.TABLE_TENNIS ||
        this.match.discipline === DisciplineEnum.SQUASH ||
        this.scoreFormat.timedPointsOrGames === TimedPointsOrGames.POINT ||
        (this.bhs.isFinalSet(this.match) &&
          this.scoreFormat.lastSet !== 'WB2') ||
        lastGame.gameFormat === GameFormat.TIEBREAK
      ) {
        setIsFinished = true;
      }
    } else {
      if (
        this.bhs.isFinalSet(this.match) &&
        this.scoreFormat.lastSet === 'WB2'
      ) {
        if (
          (gameLoserNextToLastGameScore >=
            this.scoreFormat.numberOfGamesInSet &&
            gameWinnerNextToLastGameScore >=
            this.scoreFormat.numberOfGamesInSet &&
            gameWinnerNextToLastGameScore > gameLoserNextToLastGameScore) ||
          (gameWinnerNextToLastGameScore ===
            this.scoreFormat.numberOfGamesInSet - 1 &&
            gameLoserNextToLastGameScore <
            this.scoreFormat.numberOfGamesInSet - 1)
        ) {
          setIsFinished = true;
        }
      } else {
        if (
          this.scoreFormat.tiebreakAt &&
          gameWinnerNextToLastGameScore === this.scoreFormat.tiebreakAt - 1 &&
          gameLoserNextToLastGameScore === this.scoreFormat.tiebreakAt
        ) {
          // score is 5-6 and player won the game to start tie-break
          isTiebreak = true;
        } else if (
          (gameLoserNextToLastGameScore === this.scoreFormat.tiebreakAt &&
            gameWinnerNextToLastGameScore === this.scoreFormat.tiebreakAt) ||
          gameWinnerNextToLastGameScore ===
          this.scoreFormat.numberOfGamesInSet ||
          (gameWinnerNextToLastGameScore ===
            this.scoreFormat.numberOfGamesInSet - 1 &&
            gameLoserNextToLastGameScore <
            this.scoreFormat.numberOfGamesInSet - 1)
        ) {
          setIsFinished = true;
        }
      }
    }

    if (this.scoreFormat.timedPointsOrGames === TimedPointsOrGames.POINT) {
      lastGame.side1Score =
        lastGame.points[lastGame.points.length - 2]?.side1Score || 0;
      lastGame.side2Score =
        lastGame.points[lastGame.points.length - 2]?.side2Score || 0;
    } else if (sideNumber === 1) {
      lastGame.side1Score = gameWinnerNextToLastGameScore + 1;
      lastGame.side2Score = gameLoserNextToLastGameScore;
    } else {
      lastGame.side2Score = gameWinnerNextToLastGameScore + 1;
      lastGame.side1Score = gameLoserNextToLastGameScore;
    }

    const lastSet = this.bhs.getLastSet(this.match);
    lastSet.side1Score = lastGame.side1Score;
    lastSet.side2Score = lastGame.side2Score;

    // In case of code of conduct there will be a winReason Penalty
    lastGame.winReason = winReason;

    if (setIsFinished) {
      this.addSet(sideNumber);
    } else {
      this.bhs.getLastSet(this.match).games.push({
        gameFormat: isTiebreak ? GameFormat.TIEBREAK : GameFormat.STANDARD,
        gameNumber: lastGame.gameNumber + 1,
        side1Score: 0,
        side2Score: 0,
        winningSide: undefined,
        points: [],
        timestamp: new Date(),
        updated: new Date(),
        currentScoringType: this.getCurrentScoringType(this.match, isTiebreak)
      });

      this.startNewPoint(true);
    }
  }

  async addPoint(
    winningSide: number,
    winReason?: string,
    sideNumber?: number,
    shotType?: string,
    shotOutcome?: string,
    shotMadeFrom?: string,
    shotDetail?: string,
    point?: number
  ) {
    if (this.isMatchFinishedInitiated) return;
    this.addedPointValue = point || 1;
    this.bhs.doublePointStats(point && point === 2 || false);
    const nextToLastPoint = this.bhs.getNextToLastPoint(this.match);
    const lastPoint = this.bhs.getLastPoint(this.match);
    if (!lastPoint) return;
    this.previousServingSide = nextToLastPoint?.winningSide || 0;
    lastPoint.winningSide = winningSide;
    lastPoint.scoreSubmittedBy = this.authService.authUserSignal()?._id;

    if (winReason) {
      lastPoint.winReason = winReason;
      lastPoint.timestamp = new Date();
    }

    if (shotType === 'SE') {
      await this.addShot(
        sideNumber,
        shotType,
        shotOutcome,
        shotMadeFrom,
        shotDetail
      );
      if (winReason === 'W' || winReason === 'A') {
        this.addShot(
          lastPoint.server?.sideNumber === 2 ? 1 : 2,
          null,
          'O',
          'BL',
          'RE'
        );
      }
    }

    if (shotDetail === 'RE' && lastPoint.server) {
      await this.addShot(lastPoint.server.sideNumber, 'SE', 'I', 'BL', null);
      await this.addShot(
        lastPoint.server.sideNumber === 2 ? 1 : 2,
        null,
        shotOutcome,
        'BL',
        'RE'
      );
    }

    if (this.match.dist.tracking?.rallyLength) {
      if (
        shotType === 'SE' ||
        (shotDetail === 'RE' && winReason === 'U') ||
        (shotDetail === 'RE' && winReason === 'W')
      ) {
        lastPoint.rallyLength = '0-4';
      } else {
        this.isBoardDisabled = true;
        lastPoint.rallyLength = await this.scoreService.addRallyLength();
        this.isBoardDisabled = false;
      }
    }

    // TODO handle the case to get shots
    this.isStatsBoard = false;
    this.recordPoint(point);
  }

  async addShot(
    sideNumber: number,
    shotType: string,
    shotOutcome: string,
    shotMadeFrom?: string,
    shotDetail?: string
  ) {
    let bounceAt: any;
    let participant = null;
    let playerNumber: number = null;

    if (
      this.match.matchType === 'S' &&
      this.match.sides[sideNumber - 1].players[playerNumber - 1]
    ) {
      playerNumber = 1;
    } else if (this.match.matchType === 'D' && shotType === 'SE') {
      playerNumber = this.bhs.getLastPoint(this.match).server?.playerNumber;
    }

    if (
      this.match.dist.tracking?.serveLocation &&
      shotType === 'SE' &&
      shotOutcome === 'I'
    ) {
      this.isBoardDisabled = true;
      bounceAt = await this.scoreService.getServeLocation();
      this.isBoardDisabled = false;
    }

    // TODO Who is returning?

    if (playerNumber) {
      participant =
        this.match.sides[sideNumber - 1].players[playerNumber - 1].participant
          ._id;
    }

    this.bhs.getLastPoint(this.match).shots.push({
      bounceAt: bounceAt,
      participant: participant,
      shotNumber: this.bhs.getLastPoint(this.match).shots.length + 1,
      shotOutcome: shotOutcome,
      shotType: shotType,
      shotMadeFrom: shotMadeFrom,
      shotDetail: shotDetail,
      side: this.bhs.getLastPoint(this.match)?.server?.sideNumber,
    });

    if (shotDetail === 'RE' && shotOutcome === 'I') {
      this.isStatsBoard = true;
    }

    if (
      shotType === 'SE' &&
      (shotOutcome === 'O' || shotOutcome === ShotOutcomeEnum.FOOT_FAULT)
    ) {
      this.switchedServeButton = true;
    }
  }

  private async recordPoint(point: number = 1) {
    const lastPoint = this.bhs.getLastPoint(this.match);
    if (!lastPoint || !lastPoint.winningSide) {
      return;
    }
    const sideNumber = lastPoint.winningSide;
    let isAddedGame = false;

    const nextToLastPoint = this.bhs.getNextToLastPoint(this.match);
    lastPoint.scoreSubmittedBy = this.authService.authUserSignal()?._id;

    let nextToLastPointNumberOfPointsWonForWinner = 0;
    let nextToLastPointNumberOfPointsWonForLoser = 0;
    if (nextToLastPoint && this.bhs.getLastGame(this.match).points.length > 1) {
      nextToLastPointNumberOfPointsWonForWinner =
        sideNumber === 1
          ? nextToLastPoint.side1Score
          : nextToLastPoint.side2Score;
      nextToLastPointNumberOfPointsWonForLoser =
        sideNumber === 1
          ? nextToLastPoint.side2Score
          : nextToLastPoint.side1Score;
    }

    // Point score-board logic START
    if (this.match.discipline === DisciplineEnum.PICKLEBALL) {
      const setType = this.pickleballTrackerBrainService.getSetType(this.match);
      isAddedGame = this.pickleballTrackerBrainService.isAddedGame(
        this.match,
        this.scoreFormat,
        nextToLastPointNumberOfPointsWonForWinner,
        nextToLastPointNumberOfPointsWonForLoser,
        sideNumber
      );

      if (setType === SetType.STANDARD) {
        lastPoint[`side${sideNumber}Score`] =
          this.match.score.server.sideNumber === sideNumber
            ? nextToLastPointNumberOfPointsWonForWinner + 1
            : nextToLastPointNumberOfPointsWonForWinner;
      } else if (
        setType === SetType.MLP &&
        this.pickleballTrackerBrainService.switchToStandardScoringForMlp(
          this.match,
          nextToLastPointNumberOfPointsWonForWinner,
          nextToLastPointNumberOfPointsWonForLoser,
          sideNumber
        )
      ) {
        lastPoint[`side${sideNumber}Score`] =
          nextToLastPointNumberOfPointsWonForWinner;
      } else {
        lastPoint[`side${sideNumber}Score`] =
          nextToLastPointNumberOfPointsWonForWinner + 1;
      }

      lastPoint[`side${sideNumber === 1 ? 2 : 1}Score`] =
        nextToLastPointNumberOfPointsWonForLoser;
    } else if (this.match.discipline === DisciplineEnum.BADMINTON) {
      // Badminton rally scoring logic
      const setType = this.badmintonTrackerBrainService.getSetType(this.match);

      if (this.bhs.getLastGame(this.match).points.length < 2) {
        // First point of the game
        lastPoint.side1Score = sideNumber === 1 ? 1 : 0;
        lastPoint.side2Score = sideNumber === 2 ? 1 : 0;
      } else {
        // Subsequent points
        lastPoint[`side${sideNumber}Score`] = nextToLastPointNumberOfPointsWonForWinner + 1;
        lastPoint[`side${sideNumber === 1 ? 2 : 1}Score`] = nextToLastPointNumberOfPointsWonForLoser;
      }

      isAddedGame = this.badmintonTrackerBrainService.isAddedGame(
        this.match,
        this.scoreFormat,
        nextToLastPointNumberOfPointsWonForWinner,
        nextToLastPointNumberOfPointsWonForLoser,
        sideNumber
      );

    } else if (this.match.discipline === DisciplineEnum.TABLE_TENNIS) {
      // Table tennis rally scoring logic
      if (this.bhs.getLastGame(this.match).points.length < 2) {
        // First point of the game
        lastPoint.side1Score = sideNumber === 1 ? 1 : 0;
        lastPoint.side2Score = sideNumber === 2 ? 1 : 0;
      } else {
        // Subsequent points
        lastPoint[`side${sideNumber}Score`] = nextToLastPointNumberOfPointsWonForWinner + 1;
        lastPoint[`side${sideNumber === 1 ? 2 : 1}Score`] = nextToLastPointNumberOfPointsWonForLoser;
      }

      isAddedGame = this.tableTennisTrackerBrainService.isAddedGame(
        this.match,
        this.scoreFormat,
        nextToLastPointNumberOfPointsWonForWinner,
        nextToLastPointNumberOfPointsWonForLoser,
        sideNumber
      );

    } else if (this.match.discipline === DisciplineEnum.SQUASH) {
      // Check if it's HiHo (Hand-In/Hand-Out) format
      const gameType = this.squashTrackerBrainService.getGameType(this.match);
      const isHiHo = gameType === SquashGameType.ENGLISH_HIHO;
      
      if (isHiHo) {
        // HiHo scoring: Only the server scores points
        // If receiver wins, no point is awarded but serve changes (hand-out)
        const lastGame = this.bhs.getLastGame(this.match);
        const nextToLastPoint = this.bhs.getNextToLastPoint(this.match);
        const isFirstPoint = lastGame && lastGame.points.length < 2;
        // Use lastPoint.server to determine who was serving for the rally that just ended
        // lastPoint.server is set in startNewPoint() and represents the server for this point
        const serverForRally = lastPoint.server;
        const wasServerWinner = serverForRally?.sideNumber === sideNumber;
        
        if (isFirstPoint) {
          // First point of the game - check if winner was the server
          if (wasServerWinner) {
            lastPoint.side1Score = sideNumber === 1 ? 1 : 0;
            lastPoint.side2Score = sideNumber === 2 ? 1 : 0;
          } else {
            // Receiver won - no point awarded
            lastPoint.side1Score = 0;
            lastPoint.side2Score = 0;
          }
        } else {
          if (wasServerWinner) {
            // Server won (hand-in): award point
            lastPoint[`side${sideNumber}Score`] = nextToLastPointNumberOfPointsWonForWinner + 1;
            lastPoint[`side${sideNumber === 1 ? 2 : 1}Score`] = nextToLastPointNumberOfPointsWonForLoser;
            
            // Check for game win only when server scores
            isAddedGame = this.squashTrackerBrainService.isAddedGame(
              this.match,
              this.scoreFormat,
              nextToLastPointNumberOfPointsWonForWinner,
              nextToLastPointNumberOfPointsWonForLoser,
              sideNumber
            );
          } else {
            // Receiver won (hand-out): no point awarded, scores stay the same
            lastPoint[`side${sideNumber}Score`] = nextToLastPointNumberOfPointsWonForWinner;
            lastPoint[`side${sideNumber === 1 ? 2 : 1}Score`] = nextToLastPointNumberOfPointsWonForLoser;
            isAddedGame = false; // No game win check needed when no point is scored
          }
        }
      } else {
        // Rally scoring logic (existing)
        if (this.bhs.getLastGame(this.match).points.length < 2) {
          // First point of the game
          lastPoint.side1Score = sideNumber === 1 ? 1 : 0;
          lastPoint.side2Score = sideNumber === 2 ? 1 : 0;
        } else {
          // Subsequent points
          lastPoint[`side${sideNumber}Score`] = nextToLastPointNumberOfPointsWonForWinner + 1;
          lastPoint[`side${sideNumber === 1 ? 2 : 1}Score`] = nextToLastPointNumberOfPointsWonForLoser;
        }

        isAddedGame = this.squashTrackerBrainService.isAddedGame(
          this.match,
          this.scoreFormat,
          nextToLastPointNumberOfPointsWonForWinner,
          nextToLastPointNumberOfPointsWonForLoser,
          sideNumber
        );
      }
    } else {
      if (this.bhs.getLastGame(this.match).gameFormat === GameFormat.TIEBREAK) {
        this.playTiebreak(sideNumber);
        return;
      } else if (this.bhs.getLastGame(this.match).points.length < 2) {
        if (sideNumber === 1)
          lastPoint.side1Score = lastPoint.side1Score + point;
        else lastPoint.side2Score = lastPoint.side2Score + point;
      } else {
        // For timed matches with point scoring the user manually completes game and set
        if (
          this.scoreFormat.timedPointsOrGames !== TimedPointsOrGames.POINT &&
          (nextToLastPointNumberOfPointsWonForWinner === 4 ||
            (!this.scoreFormat.ads &&
              nextToLastPointNumberOfPointsWonForWinner === 3 &&
              nextToLastPointNumberOfPointsWonForLoser === 3) ||
            (nextToLastPointNumberOfPointsWonForWinner === 3 &&
              nextToLastPointNumberOfPointsWonForLoser < 3))
        ) {
          isAddedGame = true;
        } else if (
          nextToLastPointNumberOfPointsWonForWinner === 3 &&
          nextToLastPointNumberOfPointsWonForLoser === 4 &&
          !this.scoreFormat.timedSetDuration
        ) {
          lastPoint.side1Score = 3;
          lastPoint.side2Score = 3;
        } else {
          if (sideNumber === 1) {
            lastPoint.side1Score =
              nextToLastPointNumberOfPointsWonForWinner + point;
            lastPoint.side2Score = nextToLastPointNumberOfPointsWonForLoser;
          } else {
            lastPoint.side2Score =
              nextToLastPointNumberOfPointsWonForWinner + point;
            lastPoint.side1Score = nextToLastPointNumberOfPointsWonForLoser;
          }
        }
      }
    }

    if (this.scoreFormat.timedPointsOrGames === TimedPointsOrGames.POINT && lastPoint) {
      const lastGame = this.bhs.getLastGame(this.match);
      const lastSet = this.bhs.getLastSet(this.match);

      if (lastGame) {
        lastGame.side1Score = lastPoint.side1Score;
        lastGame.side2Score = lastPoint.side2Score;
      }
      
      if (lastSet) {
        lastSet.side1Score = lastPoint.side1Score;
        lastSet.side2Score = lastPoint.side2Score;
      }
    }

    if (isAddedGame) {
      this.addGame(sideNumber);
    } else {
      let changeServer = false;
      if (
        (this.match.discipline === DisciplineEnum.PICKLEBALL ||
          this.match.discipline === DisciplineEnum.BADMINTON ||
          this.match.discipline === DisciplineEnum.TABLE_TENNIS ||
          this.match.discipline === DisciplineEnum.SQUASH ||
          this.scoreFormat.timedPointsOrGames === TimedPointsOrGames.POINT) &&
        this.match?.score?.server
      ) {
        if (this.match.discipline === DisciplineEnum.BADMINTON) {
          // In badminton rally scoring, whoever wins the rally serves next
          changeServer = this.match?.score?.server.sideNumber !== sideNumber;
        } else if (this.match.discipline === DisciplineEnum.TABLE_TENNIS) {
          // Table tennis: server changes every 2 points, every 1 point at deuce (10-10)
          changeServer = this.tableTennisTrackerBrainService.shouldChangeServer(
            this.match,
            lastPoint,
            sideNumber
          );
        } 
        else if (this.match.discipline === DisciplineEnum.SQUASH) {
          // Check if it's HiHo format
          const gameType = this.squashTrackerBrainService.getGameType(this.match);
          const isHiHo = gameType === SquashGameType.ENGLISH_HIHO;
          
          if (isHiHo) {
            // HiHo: Server changes only if receiver wins (hand-out)
            // If server wins (hand-in), they continue serving
            // Use lastPoint.server to determine who was serving during the rally that just ended
            const wasServerWinner = lastPoint.server?.sideNumber === sideNumber;
            changeServer = !wasServerWinner; // Change serve if receiver won
          } else {
            // Rally scoring: whoever wins the rally serves next
            const wasServerWinner = lastPoint.server?.sideNumber === sideNumber;
            changeServer = !wasServerWinner; // Change serve if receiver won
            //changeServer = true;
          }
        } 
        else {
          const setType = this.pickleballTrackerBrainService.getSetType(this.match);

          if (
            setType === SetType.RALLY ||
            setType === SetType.MLP ||
            this.match?.score?.server.sideNumber !== sideNumber
          ) {
            changeServer = true;
          }
        }
      }

      this.startNewPoint(changeServer);
    }
  }

  private async playTiebreak(sideNumber: number) {
    const numberOfPointsInTieBreak = this.bhs.isFinalSet(this.match)
      ? this.scoreFormat.lastSetTiebreakTo
      : this.scoreFormat.tiebreakTo; // TODO handle for 5 sets
    const lastPoint = this.bhs.getLastPoint(this.match);
    const nextToLastPoint = this.bhs.getNextToLastPoint(this.match);

    let nextToLastPointWinner = 0;
    let nextToLastPointLoser = 0;
    if (nextToLastPoint && this.bhs.getLastGame(this.match).points.length > 1) {
      nextToLastPointWinner =
        sideNumber === 1
          ? nextToLastPoint.side1Score
          : nextToLastPoint.side2Score;
      nextToLastPointLoser =
        sideNumber === 1
          ? nextToLastPoint.side2Score
          : nextToLastPoint.side1Score;
    }

    let lastPointWinner = 0;
    let lastPointLoser = 0;

    if (sideNumber === 1) {
      lastPoint.side1Score = nextToLastPointWinner + 1;
      lastPoint.side2Score = nextToLastPointLoser;
      lastPointWinner = lastPoint.side1Score;
      lastPointLoser = lastPoint.side2Score;
    } else {
      lastPoint.side2Score = nextToLastPointWinner + 1;
      lastPoint.side1Score = nextToLastPointLoser;
      lastPointWinner = lastPoint.side2Score;
      lastPointLoser = lastPoint.side1Score;
    }

    // Check if tiebreak has finished and add game    
    if (
      (this.scoreFormat.tiebreakType === 'TB5' && lastPointWinner === 5) ||
      (this.scoreFormat.tiebreakType === 'TB7P' && lastPointWinner === 7)
    ) {
      this.addGame(sideNumber);
    } else if (
      ((sideNumber === 1 && lastPoint.side1Score >= numberOfPointsInTieBreak) ||
        (sideNumber === 2 &&
          lastPoint.side2Score >= numberOfPointsInTieBreak)) &&
      lastPointWinner - lastPointLoser > 1
    ) {
      this.addGame(sideNumber);
    } else {
      // If there is no winner check if we should change server inside tie-breaker
      const changeServer =
        this.scoreFormat.tiebreakType === 'TB5' ||
          this.scoreFormat.tiebreakType === 'TB7P'
          ? (lastPointWinner + lastPointLoser) % 2 === 0
          : (lastPointWinner + lastPointLoser) % 2 === 1;

      this.startNewPoint(changeServer);
    }
  }

  /**
   * Whenever timeout start, we need to deduct the total number of timeouts
   * from the side that called the timeout. The same need to notify the server
   */
  async startTimeout(teamId: string, calledBy: string, sideNumber: number) {
    // notify the user that timeout has started
    const lastPoint: Point | null = this.bhs.getLastPoint(this.match);
    const lastSet: Set | null = this.bhs.getLastSet(this.match);

    if (!lastPoint || !lastSet) return;
    const timeout = this.clocksService.getTimeoutValuesFromSet(lastSet, this.match, sideNumber);
    const sideTimeout = sideNumber == 1 ? timeout?.side1 : timeout?.side2
    const authUser: User = await this.authService.getAuthUser();
    const timeoutData: Timeout = {
      calledBy: calledBy,
      calledByUser: authUser?._id || '',
      sideNumber: sideNumber,
      pointIndex: lastPoint.pointNumber || 0,
      startedAt: new Date(),
      endedAt: null,
      duration: 0,
      teamId,
      timeoutPerSet: sideTimeout?.timeoutPerSet ?? 0,
      remainingTimeoutsPerSet: (sideTimeout?.remainingTimeoutsPerSet ?? 0) - 1,
      timeoutPerMatch: sideTimeout?.timeoutPerMatch ?? 0,
      remainingTimeoutsPerMatch: (sideTimeout?.remainingTimeoutsPerMatch ?? 0) - 1,
    };
    lastPoint.timeout?.push(timeoutData);
    await this.updateScore({ isUndo: false, isTimeoutStart: true, actionSide: sideNumber, isTimeoutEnd: false });
  }

  async endTimeout(duration: number, sideNumber: number) {
    const lastPoint: Point | null = this.bhs.getLastPoint(this.match);
    const lastSet: Set | null = this.bhs.getLastSet(this.match);
    if (!lastPoint || !lastPoint.timeout || !lastSet) return;
    const timeout = this.clocksService.getTimeoutValuesFromSet(lastSet, this.match, sideNumber);
    const sideTimeout = sideNumber == 1 ? timeout?.side1 : timeout?.side2

    const lastTimeout = lastPoint.timeout?.at(-1);
    if (lastTimeout) {
      lastTimeout.endedAt = new Date();
      lastTimeout.duration = duration;
      lastTimeout.timeoutPerSet = sideTimeout?.timeoutPerSet ?? 0,
        lastTimeout.remainingTimeoutsPerSet = sideTimeout?.remainingTimeoutsPerSet ?? 0,
        lastTimeout.timeoutPerMatch = sideTimeout?.timeoutPerMatch ?? 0,
        lastTimeout.remainingTimeoutsPerMatch = sideTimeout?.remainingTimeoutsPerMatch ?? 0
    }
    await this.updateScore({ isUndo: false, isTimeoutEnd: true, actionSide: sideNumber, isTimeoutStart: false });
  }

  async undoTimeout() {
    const lastPoint = this.bhs.getLastPoint(this.match);
    const lastSet = this.bhs.getLastSet(this.match);

    if (!lastPoint || !lastSet || !lastPoint.timeout) return;

    lastPoint.timeout = lastPoint.timeout.slice(0, -1);
    await this.updateScore({ isUndo: true, isTimeoutUndo: true });
  }

  async startBreak() {
    await this.updateScore({ isUndo: false, isBreakEnd: false, isBreakStart: true, isBreakUndo: false });
  }

  async endBreak() {
    await this.updateScore({ isUndo: false, isBreakEnd: true, isBreakStart: false, isBreakUndo: false });
  }

  async undoBreak() {
    await this.updateScore({ isUndo: false, isBreakEnd: false, isBreakStart: false, isBreakUndo: true });
  }

  private ensureSubstituteTrackInitialized(): void {
    if (!this.match.substituteTrack) {
      this.match.substituteTrack = { side1: [], side2: [] };
    }
  }

  private getTrackKey(sideNumber: number): 'side1' | 'side2' {
    return sideNumber === 1 ? 'side1' : 'side2';
  }

  private getOrCreateTracker(
    trackKey: 'side1' | 'side2',
    setNumber: number,
    sideTrack: any[]
  ): any {
    const basePolicy = this.match?.substitutionPolicy || { perSet: 0, perMatch: 0 };
    let tracker = sideTrack.find(t => t.setNumber === setNumber);
    if (!tracker) {
      const totalUsedInMatch = sideTrack.reduce((sum, t) => sum + t.usedPerSet, 0);

      tracker = {
        setNumber,
        perSet: basePolicy.perSet,
        usedPerSet: 0,
        perMatch: basePolicy.perMatch,
        totalUsedInMatch: totalUsedInMatch,
      };

      sideTrack.push(tracker);
    }
    tracker = {
      ...tracker,
      perMatch: basePolicy.perMatch,
      perSet: basePolicy.perSet,
    }

    return tracker;
  }

  private recordSubstitutionUsage(tracker: any): void {
    tracker.usedPerSet = Math.max(0, tracker.usedPerSet + 1);
    tracker.totalUsedInMatch = Math.max(0, tracker.totalUsedInMatch + 1);
  }

  private revertSubstitutionStart(tracker: any): void {
    tracker.usedPerSet = Math.min(tracker.perSet, tracker.usedPerSet - 1);
    tracker.totalUsedInMatch = Math.min(tracker.perMatch, tracker.totalUsedInMatch - 1);
  }

  private updateCourtTimeLog(
    sideNumber: number,
    playerNumber: number,
    inPlayerId: string,
    outPlayerId: string,
    authUser: User,
    currentTime: Date,
    setNumber: number,
    lastPoint: any,
    playerInfo: User
  ): IPlayerCourtTimeLog[] {
    const courtTimeLog = this.bhs.getPlayerCourtTimeLog(this.match, sideNumber);
    const updatedLog = courtTimeLog.map(player => {
      if ((player?.player?._id === outPlayerId || player?.player === outPlayerId) && player?.outTime === null) {
        const result = {
          ...player,
          outTime: currentTime,
          substitutedBy: inPlayerId,
          substitutedAt: currentTime,
          performedBy: authUser?._id || '',
          setNumber,
          pointNumber: lastPoint.pointNumber >= 2 ? lastPoint.pointNumber - 1 : 1,
          sideNumber,
          outSetNumber: setNumber,
        };
        // need to add the substitution to the last point
        lastPoint.substitutions.push(result);
        return result;
      }
      return player;
    });

    updatedLog.push({
      player: inPlayerId,
      playerNumber,
      inTime: currentTime,
      outTime: null,
      substitutedBy: null,
      substitutedAt: null,
      performedBy: authUser?._id || '',
      setNumber,
      outSetNumber: null,
      sideNumber,
      inPointNumber: lastPoint.pointNumber
    });

    // Update player info
    const participant = this.match.sides[sideNumber - 1].players[playerNumber - 1].participant;

    this.match.sides[sideNumber - 1].players[playerNumber - 1].participant = {
      ...participant,
      first_name: playerInfo.first_name,
      last_name: playerInfo.last_name,
      _id: playerInfo._id,
    }

    return updatedLog;
  }

  private async handleSubstitution(
    sideNumber: number,
    action: 'start' | 'dismiss'
  ) {
    const setNumber = this.match.sets.length;
    this.ensureSubstituteTrackInitialized();
    const trackKey = this.getTrackKey(sideNumber);
    const sideTrack = this.match?.substituteTrack[trackKey];
    const tracker = this.getOrCreateTracker(trackKey, setNumber, sideTrack);

    if (action === 'start') {
      this.recordSubstitutionUsage(tracker);
    } else if (action === 'dismiss') {
      this.revertSubstitutionStart(tracker);
    }

    //Save updated tracker back to sideTrack
    const trackIndex = sideTrack.length < setNumber ? sideTrack.length : setNumber
    sideTrack[trackIndex - 1] = tracker;

    this.match.substituteTrack = {
      ...this.match.substituteTrack,
      [trackKey]: sideTrack,
    };

    await this.updateScore({
      isUndo: action === 'dismiss',
      isSubstituteStart: action === 'start',
      isSubstituteUndo: action === 'dismiss',
      actionSide: sideNumber,
    });
  }

  async startSubstitution(sideNumber: number) {
    await this.handleSubstitution(sideNumber, 'start');
  }

  async dismissSubstitution(sideNumber: number) {
    await this.handleSubstitution(sideNumber, 'dismiss');
  }

  async endSubstitution(
    sideNumber: number,
    playerNumber: number,
    inPlayerId: string,
    outPlayerId: string,
    playerInfo: User
  ) {
    const authUser: User = await this.authService.getAuthUser();
    const currentTime = new Date();
    const setNumber = this.match.sets.length;
    const lastPoint = this.bhs.getLastPoint(this.match);
    const nextToLastPoint = this.bhs.getNextToLastPoint(this.match);
    const trackKey = this.getTrackKey(sideNumber);
    const updatedLog: any = this.updateCourtTimeLog(
      sideNumber,
      playerNumber,
      inPlayerId,
      outPlayerId,
      authUser,
      currentTime,
      setNumber,
      lastPoint,
      playerInfo
    );

    this.match.playerCourtTimeLog = {
      ...this.match.playerCourtTimeLog,
      [trackKey]: updatedLog,
    };
    if (lastPoint) {
      const onCourtPlayers = this.bhs.getOnCourtPlayers(this.match);
      if (onCourtPlayers) {
        lastPoint.onCourtPlayers = onCourtPlayers;
      }
      if (nextToLastPoint && nextToLastPoint.onCourtPlayers) {
        const sidePlayers = nextToLastPoint.onCourtPlayers[`side${sideNumber}`];
        if (sidePlayers) {
          nextToLastPoint.onCourtPlayers[`side${sideNumber}`] = sidePlayers.map(player => {
            if (player.player === outPlayerId) {
              return {
                ...player,
                outPoint: lastPoint?.pointNumber ? lastPoint?.pointNumber - 1 : 0,
                outTime: currentTime,
                outSetNumber: setNumber
              };
            }
            return player;
          });
        }
      }
    }
    this.matchService.publishScoreUpdated(this.match);
    // If the substituted player is currently active, update to the new player's ID
    if (
      lastPoint?.server?.sideNumber === sideNumber &&
      lastPoint.server.playerNumber === playerNumber
    ) {
      lastPoint.server.player = inPlayerId;
    }
    this.updateScore({ isUndo: false, isSubstituteEnd: true, actionSide: sideNumber, isSubstituteStart: false, isEndPoint: false, isStartPoint: false });
  }

  onStartPointFromIntennseUI() {
    // update the start point timestamp for the last point
    const lastPoint = this.bhs.getLastPoint(this.match);
    if (lastPoint) {
      lastPoint.startPointTimeStamp = new Date();
    }
    this.updateScore({ isUndo: false, isStartPoint: true, isEndPoint: false })
  }

  private async startNewPoint(changeServer: boolean) {
    const lastGame: Game = this.bhs.getLastGame(this.match) || new Game();

    lastGame.points.push(new Point());
    const nextToLastPoint = this.bhs.getNextToLastPoint(this.match);

    let lastPoint: Point = this.bhs.getLastPoint(this.match) || ({} as Point);
    let last3Points: Point[] = this.bhs.getLastThreePointsFromLastGame(this.match);

    // For rally scoring sports (badminton, pickleball), inherit current game scores
    // For other sports, start at 0
    if (this.match.discipline === DisciplineEnum.PICKLEBALL) {
      const currentGame = this.bhs.getLastGame(this.match);
      lastPoint.side1Score = currentGame.side1Score || 0;
      lastPoint.side2Score = currentGame.side2Score || 0;
    } else {
      lastPoint.side1Score = 0;
      lastPoint.side2Score = 0;
    }
    lastPoint.pointNumber = lastGame.points.length;
    lastPoint.shots = [];
    lastPoint.playerPositions = structuredClone(nextToLastPoint?.playerPositions);
    lastPoint.extensions = lastPoint.extensions || [];
    lastPoint.extensions.push({
      name: 'areSidesReversed',
      value: this.bhs.getAreSidesReversed(this.match),
    });
    lastPoint.startPointTimeStamp = new Date();
    const onCourtPlayers = this.bhs.getOnCourtPlayers(this.match);
    // when start point is called from Intennse UI, we need to get the onCourtPlayers from the match 
    // and set only player id is set in the point.onCourtPlayers
    if (onCourtPlayers?.side1[0]?.player?.length > 0) {
      lastPoint.onCourtPlayers = onCourtPlayers;
    }

    if (nextToLastPoint.server) {
      if (this.match.discipline === DisciplineEnum.PICKLEBALL) {
        if (
          this.pickleballTrackerBrainService.getSetType(this.match) ===
          SetType.STANDARD ||
          this.pickleballTrackerBrainService.getSetType(this.match) ===
          SetType.RALLY
        ) {
          if (
            nextToLastPoint.server.sideNumber === nextToLastPoint.winningSide
          ) {
            let returnerPlayerNumber = 1;
            if (this.match.matchType === 'D') {
              returnerPlayerNumber =
                nextToLastPoint.server.returnerPlayerNumber === 1 ? 2 : 1;
            }

            lastPoint.server = {
              ...nextToLastPoint.server,
              ...{
                returnerPlayerNumber,
                returningSide:
                  nextToLastPoint.server.returningSide === CourtSide.DEUCE
                    ? CourtSide.AD
                    : CourtSide.DEUCE,
              },
            };
            if (this.match.matchType === 'S' && this.pickleballTrackerBrainService.getSetType(this.match) ===
              SetType.STANDARD) {
              lastPoint.server.serverNumber = 1;
            }
          } else {
            lastPoint.server =
              this.pickleballTrackerBrainService.getSetType(this.match) ===
                SetType.STANDARD
                ? this.pickleballTrackerBrainService.getStandardSetServerOnChange(
                  nextToLastPoint.server,
                  this.match.sides,
                  this.match.matchType,
                  lastPoint.playerPositions,
                  this.match.score
                )
                : this.pickleballTrackerBrainService.getRallySetServerOnChange(
                  nextToLastPoint,
                  this.match.sides,
                  this.match.matchType
                );
          }
        } else {
          // Determine the side number
          const sideNumber = nextToLastPoint?.winningSide || 1;
          let returningSideNumber = sideNumber === 1 ? 2 : 1;
          // Determine the returning side
          let currentSideScore = this.getCurrentScore(
            parseInt(this.match?.score?.[`side${sideNumber}PointScore`]),
            parseInt(
              this.match?.score?.[`side${returningSideNumber}PointScore`]
            )
          );

          // Determine the returning side
          const returningSide = this.bhs.getReturningSide(
            currentSideScore,
            this.match,
            this.scoreFormat
          );
          // Get player positions
          const playerPositions: PlayerPosition =
            nextToLastPoint?.playerPositions || {};

          // Get serving and returning players
          const { servingPlayer, returningPlayer } =
            this.getServingAndReturningPlayers(
              returningSide,
              playerPositions,
              sideNumber
            );

          // Assign the server details
          lastPoint.server = this.getServerDetails(
            nextToLastPoint,
            servingPlayer,
            returningSide,
            returningPlayer,
            sideNumber
          );
        }
      } else if (this.match.discipline === DisciplineEnum.BADMINTON) {
        const isNewSet = lastGame.gameNumber === 1 && lastPoint.pointNumber === 1;
        // Rally scoring (badminton): winner of rally serves next.
        if (nextToLastPoint.server.sideNumber === nextToLastPoint.winningSide) {
          // same side continues serving -> they keep serving but players swap (doubles)
          let returnerPlayerNumber = 1;
          if (this.match.matchType === 'D') {
            returnerPlayerNumber =
              nextToLastPoint.server.returnerPlayerNumber === 1 ? 2 : 1;
          }
          let returnerSideNumber = nextToLastPoint?.server?.sideNumber === 1 ? 2 : 1;
          const returnerPlayerId =
            this.match?.sides?.[returnerSideNumber - 1]?.players?.[returnerPlayerNumber - 1]?.participant?._id ?? null;
          lastPoint.server = {
            ...nextToLastPoint.server,
            ...{
              returnerPlayerNumber,
              returnerPlayerId,
              returningSide:
                nextToLastPoint.server.returningSide === CourtSide.DEUCE
                  ? CourtSide.AD
                  : CourtSide.DEUCE,
            },
          };
          
          // For doubles, players switch positions when same side continues to serve
          if (this.match.matchType === 'D' && !isNewSet) {
            lastPoint.playerPositions = await this.badmintonTrackerBrainService.updatePlayerCourtPosition(
              this.match, 
              nextToLastPoint,
              nextToLastPoint.winningSide || 1,
              {
                side1: nextToLastPoint.playerPositions?.side1 || {},
                side2: nextToLastPoint.playerPositions?.side2 || {}
              }
            );
          } else {
            lastPoint.playerPositions = structuredClone(nextToLastPoint.playerPositions) || lastPoint.playerPositions;
          }
        } else {
          // service passed to other side -> compute server based on rally rules (singles/doubles)
          lastPoint.server = this.badmintonTrackerBrainService.getRallySetServerOnChange(
            nextToLastPoint,
            this.match.sides,
            this.match.matchType,
            this.match
          );
          // update player positions for doubles after service changes (ensure positions reflect new server)
          if (this.match.matchType === 'D') { 
            lastPoint.playerPositions = structuredClone(nextToLastPoint.playerPositions) || lastPoint.playerPositions;
          }
        }
      } else if (this.match.discipline === DisciplineEnum.TABLE_TENNIS) {
        // Table Tennis serving rules:
        // - Server alternates every 2 points
        // - At deuce (10-10), server alternates every 1 point
        // - In doubles: Teams alternate every 2 points, players within team alternate every 2 points
        const lastSet = this.bhs.getLastSet(this.match);
        const isNewSet = lastSet && lastSet.setNumber > 1 && lastGame.gameNumber === 1 && lastPoint.pointNumber === 1;
        if (isNewSet && lastSet.setNumber) {
          // For new set (Set 2+), determine server based on set alternation pattern
          // Get the first server from Set 1 (the very first set)
          const firstSet = this.match.sets?.[0];
          const firstSetFirstGame = firstSet?.games?.[0];
          const firstServer = firstSetFirstGame?.points?.[0]?.server;
          const firstServerSide = firstServer?.sideNumber || 1;
          
          // For table tennis, the serving side alternates between sets
          // Set 1: firstServerSide serves first
          // Set 2: opposite side serves first
          // Set 3: firstServerSide serves first again
          // Pattern: If Set 1 had Side X, then Set N should have Side X if N is odd, opposite if N is even
          const currentSetNumber = lastSet.setNumber;
          let servingSideForNewSet: number;
          
          if (currentSetNumber % 2 === 1) {
            // Odd set number (1, 3, 5...) - same side as Set 1
            servingSideForNewSet = firstServerSide;
          } else {
            // Even set number (2, 4, 6...) - opposite side of Set 1
            servingSideForNewSet = firstServerSide === 1 ? 2 : 1;
          }
          
          // For singles, use the calculated servingSideForNewSet directly
          if (this.match.matchType === 'S') {
            lastPoint.server = await this.tableTennisTrackerBrainService.createServerObject(
              this.match,
              servingSideForNewSet,
              1, // playerNumber is always 1 for singles
              false // selectReturner is false for singles
            );
          }else{
            const lastSet = this.bhs.getLastSet(this.match);
            const isNewSetStart = !!(lastSet && lastSet.setNumber && lastSet.setNumber > 1 && lastGame.gameNumber === 1 && lastPoint.pointNumber === 1);
            // Only handle doubles new set here if server wasn't already set in startNewPoint
            // This is a fallback in case the first location didn't set it
            if (isNewSetStart && lastSet.setNumber && this.match.matchType === 'D' && !lastPoint.server) {
              lastPoint.server = await this.tableTennisTrackerBrainService.selectServer(
                this.match,
                false,
                undefined,
                // compute servingSideForNewSet same as above
                (() => {
                  const firstSet = this.match.sets?.[0];
                  const firstServerSide = firstSet?.games?.[0]?.points?.[0]?.server?.sideNumber || 1;
                  return (lastSet.setNumber % 2 === 1) ? firstServerSide : (firstServerSide === 1 ? 2 : 1);
                })()
              );
              if (lastPoint.server) {
                lastPoint.playerPositions = {
                  side1: this.tableTennisTrackerBrainService.getPlayerPosition(1) || {},
                  side2: this.tableTennisTrackerBrainService.getPlayerPosition(2) || {},
                };
                // await this.updateScore({ isUndo: false });
              }
            }
          }
        } else if (nextToLastPoint.server) {
          // For ongoing game, only change server if changeServer is true
          if (changeServer) {
            // Restore player positions from previous point before determining next server
            // This ensures the internal state is in sync with the previous point's positions
            if (this.match.matchType === 'D' && nextToLastPoint.playerPositions) {
              this.tableTennisTrackerBrainService.restorePlayerPositions(nextToLastPoint.playerPositions);
            }
            
            // Determine next server based on table tennis serving rules
            const nextServerInfo = this.tableTennisTrackerBrainService.getNextServer(
              this.match,
              nextToLastPoint,
              nextToLastPoint.server
            );
            
            if (nextServerInfo) {
              // Create server object with proper returner selection for doubles
              lastPoint.server = await this.tableTennisTrackerBrainService.createServerObject(
                this.match,
                nextServerInfo.sideNumber,
                nextServerInfo.playerNumber,
                this.match.matchType === 'D', // Select returner for doubles
                nextToLastPoint.server // Pass previous server for rotation calculation
              );
              
              // Update player positions after server object creation
              if (lastPoint.server && this.match.matchType === 'D') {
                const side1Position = this.tableTennisTrackerBrainService.getPlayerPosition(1);
                const side2Position = this.tableTennisTrackerBrainService.getPlayerPosition(2);
                
                if (side1Position || side2Position) {
                  lastPoint.playerPositions = {
                    side1: side1Position || {},
                    side2: side2Position || {},
                  };
                }
              }
                          
              if (!lastPoint.server) {
                // Fallback: keep same server if creation fails
                lastPoint.server = { ...nextToLastPoint.server };
              }
            } else {
              // Fallback: keep same server if we can't determine next server
              lastPoint.server = { ...nextToLastPoint.server };
            }
          } else {
            // Server doesn't change, keep the same server
            lastPoint.server = { ...nextToLastPoint.server };
          }
        } else {
          // Fallback: if no previous server, create a default one
          lastPoint.server = nextToLastPoint.server || {
            sideNumber: 1,
            playerNumber: 1,
            returnerSideNumber: 2,
            returningSide: CourtSide.DEUCE,
            returnerPlayerNumber: 1,
          };
        }
        
      } else if (this.match.discipline === DisciplineEnum.SQUASH) {

         if (nextToLastPoint?.server) {
          // For ongoing game, service changes to the winner of the rally
          // Skip if it's a new set (handled separately later)
          lastPoint.server = this.squashTrackerBrainService.getRallySetServerOnChange(
            nextToLastPoint,
            this.match.sides,
            this.match.matchType,
            this.match
          );
          // Update player positions for doubles after service changes
          if (this.match.matchType === 'D') {
            lastPoint.playerPositions = structuredClone(nextToLastPoint.playerPositions) || lastPoint.playerPositions;
          }
        } else  {
          // Fallback: if no previous server, create a default one
          // Skip if it's a new set (handled separately later)
          lastPoint.server = nextToLastPoint?.server || {
            sideNumber: 1,
            playerNumber: 1,
            returnerSideNumber: 2,
            returningSide: CourtSide.DEUCE,
            returnerPlayerNumber: 1,
          };
        }
        // Note: If isNewSet is true, server selection is handled in the new set section below
      } else {
        lastPoint.server = {
          sideNumber: nextToLastPoint.server?.sideNumber,
          playerNumber: nextToLastPoint.server?.playerNumber,
          player: nextToLastPoint.server?.player,
          returningSide: this.bhs.getReturningSide(lastPoint?.pointNumber, this.match, this.scoreFormat),
          serverNumber: nextToLastPoint.server.serverNumber,
        };
      }
    }

    /**
     * For Pickleball doubles matches, update player positions whenever there's a change in the server.
     * This is determined by a score change between the last two points, indicating a rally win.
     * If the score has changed, update the player positions based on the latest server details.
     * This is only for SIDEOUT (Standard)
     */
    const setType = this.pickleballTrackerBrainService.getSetType(this.match);
    if (
      this.match.discipline === DisciplineEnum.PICKLEBALL &&
      this.match.matchType === 'D' &&
      last3Points?.length > 1 && setType === SetType.STANDARD &&
      (
        last3Points[0].side1Score !== last3Points[1].side1Score ||
        last3Points[0].side2Score !== last3Points[1].side2Score)
    ) {
      lastPoint.playerPositions = await this.pickleballTrackerBrainService.updatePlayerCourtPosition(lastPoint.server, lastPoint.playerPositions)
    }

    let suggestServerChange: boolean | undefined;
    const isNewSet = lastGame.gameNumber === 1 && lastPoint.pointNumber === 1;

    if(this.match.discipline !== DisciplineEnum.TABLE_TENNIS){
      if (this.match.discipline !== DisciplineEnum.PICKLEBALL && 
          this.match.discipline !== DisciplineEnum.BADMINTON && 
          this.match.discipline !== DisciplineEnum.SQUASH
          ) {
        if (changeServer && nextToLastPoint.server) {
          suggestServerChange = await this.getSuggestServerChange(
            lastGame,
            lastPoint,
            nextToLastPoint,
            suggestServerChange
          );
        }
      } else {
        if (changeServer && isNewSet) {
          suggestServerChange = await this.getSuggestServerChange(
            lastGame,
            lastPoint,
            nextToLastPoint,
            suggestServerChange
          );
        }
      }
    }

    const updateScoreObject: UpdateScoreOptions = {
      isUndo: false,
    }
    // if its not new set, we need to mark the point as end point

    if (!isNewSet) {
      updateScoreObject.isEndPoint = this.isIntennseOfficialView;
      updateScoreObject.isStartPoint = false;

      const tie = this.match.tie;
      if (tie) {
        const sideNumber = nextToLastPoint?.winningSide;
        const tieId = typeof tie === "string" ? tie : tie?._id;

        if (tieId) {
          const tieScore = this.bhs.getCurrentTieScore(tieId);

          if (tieScore) {
            if (sideNumber === 1) {
              tieScore.side1Score += this.addedPointValue;
            } else {
              tieScore.side2Score += this.addedPointValue;
            }

            this.match.tieScore = tieScore;
          }
        }
      }
    }

    await this.updateScore(updateScoreObject);

    this.switchedServeButton = false;
    this.isStatsBoard = false;

    if (suggestServerChange) {
      if (this.match.discipline !== DisciplineEnum.PICKLEBALL && 
        this.match.discipline !== DisciplineEnum.BADMINTON && 
        this.match.discipline !== DisciplineEnum.TABLE_TENNIS &&
        this.match.discipline !== DisciplineEnum.SQUASH
        ) {
        await this.changeServer();
        await this.changeReturnerSide();
      } else if(this.match.discipline === DisciplineEnum.SQUASH) {
        lastPoint.server = await this.squashTrackerBrainService.selectServer(
          this.match,
          false, // showCancelButton = false
        );
         await this.updateScore({ isUndo: false });
      } else {
        lastPoint = await this.changeServerForPickleball(lastPoint);
      }
    }

    if(this.match.discipline === DisciplineEnum.SQUASH) {
      const currentSide1Score = nextToLastPoint.side1Score || 0;
      const currentSide2Score = nextToLastPoint.side2Score || 0;
      if (this.squashTrackerBrainService.shouldShowTieBreakModal(
        this.match,
        this.scoreFormat,
        currentSide1Score,
        currentSide2Score
      )) {
        const tieBreakChoice = await this.squashTrackerBrainService.selectTieBreakOption(
          this.scoreFormat.numberOfPointsInGame || 9
        );
        if (tieBreakChoice) {
          this.squashTrackerBrainService.storeTieBreakChoice(this.match, tieBreakChoice);
        }
      }
    }
  }

  /**
   * This method is to handle special case for PICKLEBALL serving side when any side win
   * and the current score is 20 and opponent score is less than 20.
   * In this case the point remain same and service need to be done from Deuce side.
   * @param servingSideScore number
   * @param returningSideScore number
   * @returns number
   */
  private getCurrentScore(
    servingSideScore: number,
    returningSideScore: number
  ): number {
    if (servingSideScore === 20 && returningSideScore <= 19) {
      return servingSideScore - 1;
    }
    return servingSideScore;
  }

  private async getSuggestServerChange(
    lastGame: Game,
    lastPoint: Point,
    nextToLastPoint: Point,
    suggestServerChange: boolean
  ) {
    const isNewSet = lastGame.gameNumber === 1 && lastPoint.pointNumber === 1;

    let changeServerResult: {
      server?: Server;
      suggestServerChange: boolean;
    };

    switch (this.match.discipline) {
      case DisciplineEnum.PICKLEBALL:
        changeServerResult = this.pickleballTrackerBrainService.changeServer(
          this.match,
          this.scoreFormat,
          nextToLastPoint.winningSide
        );
        break;

      case DisciplineEnum.BADMINTON:
        changeServerResult = this.badmintonTrackerBrainService.changeServer(
          this.match,
          this.scoreFormat,
          nextToLastPoint.winningSide,
          isNewSet
        );
        break;

      case DisciplineEnum.SQUASH:
        changeServerResult = this.squashTrackerBrainService.changeServer(
          this.match,
          this.scoreFormat,
          nextToLastPoint.winningSide,
          isNewSet
        );
        break;

      default: // Tennis, etc.
        changeServerResult = await this.serverService.changeServer(
          this.match,
          this.scoreFormat,
          isNewSet
        );
        break;
    }


    lastPoint.server = changeServerResult.server;
    suggestServerChange = changeServerResult.suggestServerChange;
    return suggestServerChange;
  }

  private async changeServerForPickleball(lastPoint: Point): Promise<Point> {
    if (!lastPoint || !lastPoint.server) return lastPoint;

    const previousSetServe = this.bhs.getLastSetServingAndReturningSide(
      this.match
    );
    const nextSideNumber = previousSetServe?.sideNumber === 1 ? 2 : 1;
    const selectedServer = this.match.matchType === 'D' ? await this.pickleballTrackerBrainService.selectServer(
      this.match,
      false,
      lastPoint.server?.serverNumber,
      nextSideNumber
    ) : await this.pickleballTrackerBrainService.autoSelectServerForSinglesAfterFirstSet(
      this.match,
      nextSideNumber
    );

    if (!selectedServer) return lastPoint;
    
    /**
     * In some case, the actual reference to the lastPoint to match got lost 
     * so we need to create a new last point object with the last point data from latest match object
     */
    let actualLastPoint:any = this.bhs.getLastPoint(this.match);
    if (!actualLastPoint) {
      actualLastPoint = {
        ...lastPoint,        
      };
    }
    // Destructure selected server for cleaner assignment
    const {
      sideNumber,
      serverNumber,
      playerNumber,
      player,
      returnerPlayerNumber,
    } = selectedServer;

    Object.assign(actualLastPoint?.server || {}, {
      sideNumber,
      serverNumber,
      playerNumber,
      player,
      returnerSideNumber: sideNumber === 1 ? 2 : 1,
      returnerPlayerNumber,
      returningSide: CourtSide.DEUCE, // start of any point from DEUCE side by default
    });

    actualLastPoint.playerPositions = this.getPlayerPositions();

    // Update server order and score
    this.bhs.getLastSet(this.match).serverPickleballOrders =
      this.pickleballTrackerBrainService.setServerOrder(
        this.match,
        actualLastPoint?.server || {} as Server
      );

    await this.updateScore({isUndo: false});
    return actualLastPoint || lastPoint;
  }

  private getPlayerPositions(): { side1: any; side2: any } {
    return {
      side1: this.pickleballTrackerBrainService.getPlayerPosition(1) ?? {},
      side2: this.pickleballTrackerBrainService.getPlayerPosition(2) ?? {},
    };
  }

  private async changeServer() {
    const selectedServer = await this.serverService.selectPlayerFromSide(
      this.match,
      this.bhs.getLastPoint(this.match).server.sideNumber
    );
    const lastPoint = this.bhs.getLastPoint(this.match);

    lastPoint.server.playerNumber = selectedServer.playerNumber;
    lastPoint.server.player = selectedServer.participant?._id;
  }

  private async changeReturnerSide() {
    this.bhs.getLastSet(this.match).returnerCourtSides =
      await this.serverService.getReturnerCourtSides(
        this.match,
        this.bhs.getLastPoint(this.match).server.sideNumber === 1 ? 2 : 1
      );
    await this.updateScore({ isUndo: false });
  }
  isSendNotification(): boolean {
    if (!this.match || !this.match.sets?.length) {
      return false;
    }
    if (this.scoreFormat?.setType !== SetType.TIMED) {
      return true;
    }

    const lastSet = this.bhs.getLastSet(this.match);
    if (lastSet?.isCompleted === true) {
      return true;
    }
    if (lastSet && lastSet.games?.length == 1 && lastSet.games[0].points?.length == 1) {
      return true;
    }

    return false;
  }
  private async updateMatch(isUndo: boolean) {
    let loading = await this.loadingController.getTop();
    if (!loading) {
      loading = await this.loadingController.create({
        message: this.translateService.instant('Updating match...'),
      });
      await loading.present();
    }

    this.match.score = this.scoreService.getScoreObject(this.match);
    const lastPoint: any = this.bhs.getLastPoint(this.match);
    if (lastPoint) {
      lastPoint.deviceMeta = this.deviceMetaService.getDeviceMeta();
    }

    this.matchService
      .update(this.match, isUndo, this.notification)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => loading.dismiss())
      )
      .subscribe({
        next: () => {
          this.matchService.publishEdit(this.match);
          this.matchService.publishScoreUpdated(this.match);
          this.notification = null;

          // If this is a tie
          // Match status needs to be updated when match is updated
          // Making a call to get tie matches and call function to recalculate and update tie status
          if (this.match.tie) {
            this.tieDetailsService.tieStatusUpdate(this.isSendNotification());
          }
          this.isMatchFinishedInitiated = false;
        }, error: () => {
          this.isMatchFinishedInitiated = false;
        }
      });
  }

  private async updateScore(options: UpdateScoreOptions) {
    // Don't call updateScore if match is already completed
    if (this.match.matchStatus === MatchUpStatusEnum.COMPLETED) {
      return;
    }
    this.updateScore$.next({ updateScoreOption: options });
  }

  private async ensureMatchSetsLoaded() {
    if (!this.match.sets || this.match.sets.length === 0) {
      const loading = await this.loadingController.create({
        message: this.translateService?.instant?.('Updating match...') || 'Updating match...'
      });
      await loading.present();
      const res = await firstValueFrom(this.matchService.show(this.match._id));
      if (res && res.data) {
        this.match = res.data;
      }
      //dismniss loading after 5 seconds in case of any issue
      setTimeout(() => {
        loading.dismiss();
      }, 5000);
    }
  }

  async undo(removeAll?: boolean, isActionFromIntennse?: boolean) {
    try {
      await this.ensureMatchSetsLoaded();
    } catch (error) {
      console.error('Failed to load match data:', error);
      const topLoader = await this.loadingController.getTop();
      if (topLoader) {
        await topLoader.dismiss();
      }
      this.toastService.presentDangerToast('Failed to load match data. Please try again.');
      return;
    }

    let shouldUpdateTieScore = false;

    if (this.isStatsBoard || this.switchedServeButton) {
      this.resetStatsOrServeButtonFlags();
      shouldUpdateTieScore = true;
      return this.updateTieScoreIfNeeded(shouldUpdateTieScore);
    }

    if (this.isWalkoverMatch()) {
      this.revertWalkover();
      shouldUpdateTieScore = true;
      return this.updateTieScoreIfNeeded(shouldUpdateTieScore);
    }

    if (this.isPostMatchStatus()) {
      await this.revertPostMatchStatus();
      shouldUpdateTieScore = true;
      return this.updateTieScoreIfNeeded(shouldUpdateTieScore);
    }

    if (this.isFirstPointScenario(removeAll, isActionFromIntennse)) {
      await this.handleFirstPointScenario(removeAll);
      shouldUpdateTieScore = true;
      return this.updateTieScoreIfNeeded(shouldUpdateTieScore);
    }

    const lastPoint = this.bhs.getLastPoint(this.match);
    if (!lastPoint) return;

    if (this.hasSubstitutionsOrTimeouts(lastPoint)) {
      await this.undoLastTimeoutOrSubstitution(lastPoint);
    } else {
      await this.removePointAndUpdateScore(lastPoint);
      shouldUpdateTieScore = true;
    }

    this.updateTieScoreIfNeeded(shouldUpdateTieScore);
  }

  private updateTieScoreIfNeeded(shouldUpdate: boolean) {
    if (shouldUpdate && this.match.tie) {
      this.bhs.updateTieAggregateScore(this.match);
    }
  }

  private async handleFirstPointScenario(removeAll?: boolean) {
    const lastPoint = this.bhs.getLastPoint(this.match);
    if (!lastPoint) return;

    if (this.hasSubstitutionsOrTimeouts(lastPoint)) {
      await this.undoLastTimeoutOrSubstitution(lastPoint);
    } else {
      await this.resetFullMatch();
    }
  }

  private resetStatsOrServeButtonFlags() {
    this.isStatsBoard = false;
    this.switchedServeButton = false;
  }

  private isWalkoverMatch(): boolean {
    return this.match.matchStatus === MatchUpStatusEnum.WALKOVER;
  }

  private revertWalkover() {
    this.match = {
      ...this.match,
      matchStatus: 'TBP',
      endDate: null,
      winningSide: null,
    };
    this.updateMatch(true);
  }

  private isPostMatchStatus(): boolean {
    return [
      MatchUpStatusEnum.COMPLETED,
      MatchUpStatusEnum.RETIRED,
      MatchUpStatusEnum.DEFAULTED,
      MatchUpStatusEnum.SUSPENDED,
      MatchUpStatusEnum.INCOMPLETE,
      MatchUpStatusEnum.ABANDONED,
    ].includes(this.match.matchStatus as MatchUpStatusEnum);
  }

  private async revertPostMatchStatus() {
    if (
      this.scoreFormat.setType === SetType.TIMED &&
      this.scoreFormat.timedPointsOrGames === TimedPointsOrGames.GAME
    ) {
      this.bhs.getLastSet(this.match).games.push({
        gameFormat: GameFormat.STANDARD,
        gameNumber: this.bhs.getLastGame(this.match).gameNumber + 1,
        side1Score: 0,
        side2Score: 0,
        winningSide: null,
        points: [],
        timestamp: new Date(),
        updated: new Date(),
      });
      this.startNewPoint(true);
    }

    /**
     * If the substitution policy per set is zero and player court log exists with outTime already set,
     * this indicates the match was previously completed and players were marked as off-court.
     * In case of an undo operation, this resets all players' outTime to null to reflect that they are
     * still active in the match.
     */
    const { playerCourtTimeLog } = this.match;

    ['side1', 'side2'].forEach(side => {
      playerCourtTimeLog[side].forEach(playerEntry => {
        if (playerEntry.outTime && !playerEntry.substitutedAt) {
          playerEntry.outTime = null;
        }
        return playerEntry
      });
    });
    this.match.playerCourtTimeLog = playerCourtTimeLog;

    const lastPoint = this.bhs.getLastPoint(this.match);
    if (lastPoint) {
      // For rally scoring sports (badminton, pickleball), preserve the previous point's scores
      // For other sports, reset to 0
      let previousSide1Score = 0;
      let previousSide2Score = 0;

      if (this.match.discipline === DisciplineEnum.BADMINTON || this.match.discipline === DisciplineEnum.PICKLEBALL) {
        const lastGame = this.bhs.getLastGame(this.match);
        if (lastGame.points.length > 1) {
          const previousPoint = lastGame.points[lastGame.points.length - 2];
          previousSide1Score = previousPoint.side1Score || 0;
          previousSide2Score = previousPoint.side2Score || 0;
        }
      }

      Object.assign(lastPoint, {
        rallyLength: null,
        shots: [],
        side1Score: previousSide1Score,
        side2Score: previousSide2Score,
        timestamp: null,
        winReason: null,
        winningSide: null,
      });
    }

    const lastGame = this.bhs.getLastGame(this.match);
    lastGame.winningSide = null;
    if (this.scoreFormat.setType !== SetType.TIMED) {
      lastGame.side1Score = 0;
      lastGame.side2Score = 0;
    }

    const lastSet = this.bhs.getLastSet(this.match);
    lastSet.winningSide = null;
    lastSet.isCompleted = false;

    this.match = {
      ...this.match,
      matchStatus: 'IN_PROGRESS',
      winningSide: null,
      endDate: null,
      score: this.scoreService.getScoreObject(this.match),
    };

    this.updateMatch(true);

    if (this.match.tournament) {
      this.downloadMatchService.publishFollow(this.match);
      this.socket.emit('add-tournament-match', {
        tournamentId: this.match.tournament,
        matchUp: this.match,
      });
    }
  }

  private isFirstPointScenario(removeAll?: boolean, isActionFromIntennse?: boolean): boolean {
    const lastSet = this.bhs.getLastSet(this.match);
    const lastGame = this.bhs.getLastGame(this.match);
    return (
      this.match.sets.length === 1 &&
      lastSet?.games?.length === 1 &&
      (lastGame?.points?.length === 1) || (lastGame?.points?.length === 2 && removeAll && !isActionFromIntennse)
    );
  }

  private async resetFullMatch() {
    this.match = {
      ...this.match,
      sets: [],
      startDate: null,
      matchStatus: 'TBP',
      score: {
        scoreStringSide1: '0',
        scoreStringSide2: '0',
        side1PointScore: '0',
        side2PointScore: '0',
        sets: [],
        server: null,
      },
      playerCourtTimeLog: { side1: [], side2: [] },
      substituteTrack: { side1: [], side2: [] },
    };

    await this.matchService
      .update(this.match, true, null)
      .pipe(
        takeUntil(this.destroy$),
        tap(() => {
          this.matchService.publishEdit(this.match);
          this.matchService.publishScoreUpdated(this.match);
          this.matchService.publishFullMatchUndo({ matchId: this.match._id, isUndo: true });
        })
      )
      .toPromise();
    this.scoreService.resetPlayerPositions();
    await this.updateMatch(true);
  }

  private hasSubstitutionsOrTimeouts(point: any): boolean {
    return (point.substitutions?.length || 0) > 0 || (point.timeout?.length || 0) > 0;
  }

  private async undoLastTimeoutOrSubstitution(point: any) {
    let latestSubTime: Date | null = null;
    let latestTimeoutTime: Date | null = null;
    const undoObject: UpdateScoreOptions = { isUndo: true }

    if (point.substitutions?.length) {
      const lastSub = point.substitutions[point.substitutions.length - 1];
      latestSubTime = new Date(lastSub.outTime || lastSub.substitutedAt || 0);
    }

    if (point.timeout?.length) {
      const lastTimeout = point.timeout[point.timeout.length - 1];
      latestTimeoutTime = new Date(lastTimeout.endedAt);
    }

    if (latestSubTime && (!latestTimeoutTime || latestSubTime > latestTimeoutTime)) {
      const poppedSub = point.substitutions.pop();
      const lastPoint = this.bhs.getLastPoint(this.match);
      const nextToLastPoint = this.bhs.getNextToLastPoint(this.match);
      const { courtTimeLog, substituteTrack } = this.bhs.revertSubstitutionsAfterPoint(
        this.match.playerCourtTimeLog,
        this.match.substituteTrack,
        poppedSub,
        this.match,
        lastPoint
      );
      if (nextToLastPoint) {
        // when undo is called, we need to get the onCourtPlayers from the match and set only player id is set
        const onCourtPlayers = this.bhs.getOnCourtPlayers(this.match);
        if (onCourtPlayers?.side1[0]?.player?.length > 0) {
          nextToLastPoint.onCourtPlayers = onCourtPlayers;
        }
      }

      this.match = {
        ...this.match,
        playerCourtTimeLog: courtTimeLog,
        substituteTrack: substituteTrack,
      };

      undoObject.isSubstituteUndo = true;
      undoObject.isStartPoint = false;
      undoObject.isEndPoint = false;

    } else if (latestTimeoutTime) {
      point.timeout.pop();
      undoObject.isTimeoutUndo = true;
      undoObject.isStartPoint = false;
      undoObject.isEndPoint = false;
    }
    await this.updateScore(undoObject);

  }

  private async removePointAndUpdateScore(point: any) {
    const currentScore = {
      side1: point.side1Score || 0,
      side2: point.side2Score || 0,
    };

    this.bhs.removeLastPoint(this.match);

    if (this.match.score) {
      this.match.score.scoreStringSide1 = currentScore.side1.toString();
      this.match.score.scoreStringSide2 = currentScore.side2.toString();
    }

    // After undo, check if we need to clear tie-break choice for squash
    // This ensures that if score goes from 8-8 to 8-7, the tie-break choice is cleared
    if (this.match.discipline === DisciplineEnum.SQUASH) {
      const nextToLastPoint = this.bhs.getNextToLastPoint(this.match);
      if (nextToLastPoint) {
        const side1Score = nextToLastPoint.side1Score || 0;
        const side2Score = nextToLastPoint.side2Score || 0;
        // This will clear the tie-break choice if score is no longer at tie-break threshold
        this.squashTrackerBrainService.shouldShowTieBreakModal(
          this.match,
          this.scoreFormat,
          side1Score,
          side2Score
        );
      }
    }

    await this.updateScore({ isUndo: true });
  }

  // ******************************************
  // ************ HELPER FUNCTIONS ************
  // ******************************************

  getDuration(startDate, endDate): string {
    const duration = intervalToDuration({
      start: new Date(startDate),
      end: new Date(endDate),
    });

    return `${duration.days * 24 * 60 * 60 +
      duration.days * 60 * 60 +
      duration.minutes * 60 +
      duration.seconds
      }`;
  }

  getColor(sideNumber: number) {
    const location = sideNumber === 1 ? 'home' : 'away';

    if (this.match.tie && this.tie) {
      return this.ths.getTeamColor(
        this.tie.sides[sideNumber - 1].team,
        location
      );
    } else {
      return location === 'home' ? '#3f51b5' : '#009688';
    }
  }

  // Score buttons
  ace(sideNumber: number) {
    const winningSide = sideNumber;
    this.addPoint(winningSide, 'A', sideNumber, 'SE', 'I', 'BL', null);
  }

  serveWinner(sideNumber: number) {
    const winningSide = sideNumber;
    this.addPoint(winningSide, 'W', sideNumber, 'SE', 'I', 'BL', null);
  }

  returnWinner(sideNumber: number) {
    const winningSide = sideNumber;
    this.addPoint(winningSide, 'W', sideNumber, null, 'I', 'BL', 'RE');
  }

  returnUnforcedError(sideNumber: number) {
    const winningSide = sideNumber === 1 ? 2 : 1;
    this.addPoint(winningSide, 'U', sideNumber, 'O', 'BL', 'RE');
  }

  firstServeError(sideNumber: number, shotOutcome: string) {
    this.addShot(sideNumber, 'SE', shotOutcome, 'BL', null);
  }

  doubleFault(sideNumber: number, shotOutcome: string) {
    const winningSide = sideNumber === 1 ? 2 : 1;
    this.addPoint(winningSide, 'DF', sideNumber, 'SE', shotOutcome, 'BL', null);
  }

  singleFault(sideNumber: number, shotOutcome: string) {
    const winningSide = sideNumber === 1 ? 2 : 1;
    this.addPoint(winningSide, 'DF', sideNumber, 'SE', shotOutcome, 'BL', null);
  }

  async returnMade(sideNumber: number) {
    // Add serve
    await this.addShot(
      this.bhs.getLastPoint(this.match).server.sideNumber === 1 ? 2 : 1,
      'SE',
      'I',
      'BL',
      null
    );
    // Add return
    await this.addShot(sideNumber, null, 'I', 'BL', 'RE');
  }

  winner(sideNumber: number) {
    const winningSide = sideNumber;
    this.addPoint(winningSide, 'W', sideNumber, null, 'I');
  }

  forcedError(sideNumber: number) {
    const winningSide = sideNumber === 1 ? 2 : 1;
    this.addPoint(winningSide, 'F', sideNumber, null, 'O');
  }

  unforcedError(sideNumber: number) {
    const winningSide = sideNumber === 1 ? 2 : 1;
    this.addPoint(winningSide, 'U', sideNumber, null, 'O');
  }

  subscriptions() {
    
    this.matchService
      .subscribeEdit()
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (updatedMatch) => {
       
        if (this.match._id === updatedMatch._id) {
          const updatedScoreFormat = this.bhs.getScoreFormat(
            updatedMatch.matchFormat,
            this.match.discipline || DisciplineEnum.TENNIS,
            this.match?.score
          );
          this.match = updatedMatch;
          // Check if this is a TB10@6 format and the lastSet difference is due to score state (6-6 vs not 6-6)
          const isTB10at6Format = this.match.matchFormat.includes("TB10@6");
          const isLastSet = this.scoreFormat.numberOfSets === this.match.sets.length;
          const lastSetChanged = this.scoreFormat.lastSet !== updatedScoreFormat.lastSet;

          // For TB10@6 format, only trigger startNewSet if the change is not just due to score state transition
          // (empty string <-> "TB10@6" based on 6-6 score)
          if (isLastSet && (lastSetChanged || this.match?.isMatchFormatChanged)) {
            if (!isTB10at6Format) {
              // For non-TB10@6 formats, proceed with original logic
              this.match.sets.splice(-1, 1);
              this.startNewSet();
            } else {
              // For TB10@6 format, check if this is a real format change or just score state change
              const isScoreStateChange =
                (this.scoreFormat.lastSet === '' && updatedScoreFormat.lastSet === 'TB10@6') ||
                (this.scoreFormat.lastSet === 'TB10@6' && updatedScoreFormat.lastSet === '');

              if (!isScoreStateChange) {
                // This is a real format change, not just score state
                this.match.sets.splice(-1, 1);
                this.startNewSet();
              }
            }
          }
          this.scoreFormat = this.bhs.getScoreFormat(
            this.match.matchFormat,
            this.match.discipline || DisciplineEnum.TENNIS,
            this.match?.score
          );
          this.match.score = this.scoreService.getScoreObject(this.match);
        }
      });
    if(!this.intennseView){
      return;
    }
    this.playerServerUpdateSubscription = this.scoreService
      .updateServingPlayerSubscription()
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (data: any) => {
        const { selectedServer, playerPositions } = data;
        let lastPoint: Point | null = this.bhs.getLastPoint(this.match);
        if (lastPoint && lastPoint.server) {
          lastPoint.server.playerNumber = selectedServer.playerNumber;
          lastPoint.server.sideNumber = selectedServer.sideNumber;
          lastPoint.server.player = selectedServer.palyerId;
          this.bhs.doublePointStats(true);
          lastPoint.playerPositions = playerPositions;
          lastPoint.playerPositions[`side${selectedServer.sideNumber}`] = playerPositions?.[`side${selectedServer.sideNumber}`] || {};
          await this.updateScore({ isUndo: false });
        }
      });
  }

  private getServingAndReturningPlayers(
    returningSide: string,
    playerPositions: PlayerPosition,
    sideNumber?: number
  ): { servingPlayer: PlayerInfo; returningPlayer: PlayerInfo } {
    const side1PlayerPosition: PlayerCourtPosition = playerPositions?.side1;
    const side2PlayerPosition: PlayerCourtPosition = playerPositions?.side2;

    const servingPlayerDetails: PlayerCourtPosition =
      sideNumber === 1 ? side1PlayerPosition : side2PlayerPosition;
    const returningPlayerDetails: PlayerCourtPosition =
      sideNumber === 1 ? side2PlayerPosition : side1PlayerPosition;

    return {
      servingPlayer: servingPlayerDetails?.[returningSide.toLowerCase()],
      returningPlayer: returningPlayerDetails?.[returningSide.toLowerCase()],
    };
  }

  private getServerDetails(
    nextToLastPoint: any,
    servingPlayer: any,
    returningSide: CourtSide,
    returningPlayer: any,
    sideNumber?: number
  ): Server {
    return {
      sideNumber: sideNumber,
      playerNumber: servingPlayer?.playerNumber,
      player: servingPlayer?.player,
      returningSide: returningSide,
      returnerSideNumber: nextToLastPoint?.server?.sideNumber === 1 ? 2 : 1,
      returnerPlayerNumber: returningPlayer?.playerNumber,
    };
  }

  getPlayerServeStats(match) {
    const stats = {};

    const courtTimeMap = (match.playerCourtTimeLog || []).reduce((map, log) => {
      if (!log.playerId) return map;
      if (!map[log.playerId]) map[log.playerId] = [];
      map[log.playerId].push({
        in: new Date(log.inTime).getTime(),
        out: log.outTime ? new Date(log.outTime).getTime() : Infinity
      });
      return map;
    }, {});
    return courtTimeMap; 
  }

  initializePlayerStats(match) {
    const playerStatsMap = {};

    // Combine all player logs from both sides
    const allPlayerLogs = [
      ...(match?.playerCourtTimeLog?.side1 || []),
      ...(match?.playerCourtTimeLog?.side2 || [])
    ];

    for (const log of allPlayerLogs) {
      const player = log.player;
      const playerId = player._id;

      if (!playerStatsMap[playerId]) {
        // First time we see this player, initialize their object
        playerStatsMap[playerId] = {
          playerId,
          fullName: `${player.first_name} ${player.last_name}`,
          sideNumber: log.sideNumber,
          appearances: [],
          totalCourtTimeInMilliSeconds: 0,
          totalCourtTimeInMinutesHour: 0,
          stats: {

            servePointsPlayedCount: 0,
            wonServePointsCount: 0,
            wonServePointsValue: 0,
            lostServePointsCount: 0,
            lostServePointsValue: 0,

            // for single match only
            returnPointsPlayedCount: 0,
            wonReturnPointsCount: 0,
            wonReturnPointsValue: 0,

            lostDoubleFaultsCount: 0,

            // for single match only
            wonDoubleFaultsCount: 0,

            wonTwoPointPlaysCount: 0,
            wonTwoPointPlaysValue: 0,

            // for single match only
            lostTwoPointPlaysCount: 0,
            lostTwoPointPlaysValue: 0,
            wonReturnTwoPointPlaysCount: 0,
            wonReturnTwoPointPlaysValue: 0,
            lostReturnTwoPointPlaysCount: 0,
            lostReturnTwoPointPlaysValue: 0,


            //Count-based
            currentWinningStreakCount: 0,
            maxWinningStreakCount: 0,
            currentLosingStreakCount: 0,
            maxLosingStreakCount: 0,

            //Value-based
            currentWinningStreakValue: 0,
            maxWinningStreakValue: 0,
            currentLosingStreakValue: 0,
            // maxLosingStreakValue: 0,

            plusMinusCount: 0,
            plusMinusValue: 0,
            // subImpact: [] as SubImpactStat[],
          }
        };
      }

      // Add this appearance to the player's log
      playerStatsMap[playerId].appearances.push({
        inTime: log.inTime,
        outTime: log.outTime,
        setNumber: log.setNumber
      });
    }

    return playerStatsMap;
  }

  // calculateServeStats(match, playerStatsMap) {
  //   if (!match.sets || !Array.isArray(match.sets)) return;

  //   const allPoints = match.sets.flatMap(set => set.games?.[0]?.points || []);    

  //   const sideStats = {
  //     1: {
  //       // Serve-related
  //       servePointsPlayedCount: 0,  // total times side 1 served
  //       wonServePointsCount: 0,     // count of serve points won
  //       lostServePointsCount: 0,    // count of serve points lost
  //       wonServePointsValue: 0, // total points won while serving
  //       lostServePointsValue: 0, // total points lost while serving

  //       // Return-related
  //       returnPointsPlayedCount: 0, // total times side 1 returned
  //       wonReturnPointsCount: 0,    // count of return points won
  //       lostReturnPointsCount: 0,   // count of return points lost
  //       wonReturnPointsValue: 0, // total points won while returning
  //       lostReturnPointsValue: 0, // total points lost while returning

  //       // Errors
  //       lostDoubleFaultsCount: 0,
  //       wonDoubleFaultsCount: 0,       // double faults by side 1

  //       // // 2-point play stats
  //       wonTwoPointPlaysCount: 0,
  //       wonTwoPointPlaysValue: 0,
  //       lostTwoPointPlaysCount: 0,
  //       lostTwoPointPlaysValue: 0,

  //       // 2-point play breakdown by serve/return
  //       wonTwoPointServeCount: 0,
  //       wonTwoPointServeValue: 0,
  //       wonTwoPointReturnCount: 0,
  //       wonTwoPointReturnValue: 0,

  //       lostTwoPointServeCount: 0,
  //       lostTwoPointServeValue: 0,
  //       lostTwoPointReturnCount: 0,
  //       lostTwoPointReturnValue: 0,
  //       // // Streaks
  //       currentLosingStreak: 0,
  //       maxLosingStreak: 0,
  //       currentWinningStreak: 0,
  //       maxWinningStreak: 0,
  //     },
  //     2: {
  //       // Same as above for side 2
  //       servePointsPlayedCount: 0,
  //       wonServePointsCount: 0,
  //       lostServePointsCount: 0,
  //       wonServePointsValue: 0,
  //       lostServePointsValue: 0,

  //       returnPointsPlayedCount: 0,
  //       wonReturnPointsCount: 0,
  //       lostReturnPointsCount: 0,
  //       wonReturnPointsValue: 0,
  //       lostReturnPointsValue: 0,

  //       lostDoubleFaultsCount: 0,
  //       wonDoubleFaultsCount: 0,

  //       wonTwoPointPlaysCount: 0,
  //       wonTwoPointPlaysValue: 0,
  //       lostTwoPointPlaysCount: 0,
  //       lostTwoPointPlaysValue: 0,

  //       // 2-point play breakdown by serve/return
  //       wonTwoPointServeCount: 0,
  //       wonTwoPointServeValue: 0,
  //       wonTwoPointReturnCount: 0,
  //       wonTwoPointReturnValue: 0,

  //       lostTwoPointServeCount: 0,
  //       lostTwoPointServeValue: 0,
  //       lostTwoPointReturnCount: 0,
  //       lostTwoPointReturnValue: 0,

  //       currentLosingStreak: 0,
  //       maxLosingStreak: 0,
  //       currentWinningStreak: 0,
  //       maxWinningStreak: 0,
  //     }
  //   };

  //   let lastScoreBySide = {
  //     1: null,
  //     2: null
  //   };    


  //   const lastScoreBySideForPlayerStreak = {
  //     1: 0,
  //     2: 0
  //   };

  //   const lastScoreBySideForPlusMinus = {
  //     1: 0,
  //     2: 0,
  //   };

  //   // Exclude last point if match is still in progress
  //   if (match.matchStatus === "IN_PROGRESS" && allPoints.length > 0) {
  //     allPoints.pop(); // Remove the last point
  //   }

  //   const isSinglesMatch = match.sides?.[0]?.players?.length === 1 && match.sides?.[1]?.players?.length === 1;


  //   for (let i = 0; i < allPoints.length; i++) {
  //     const point = allPoints[i]
  //     const server = point.server;
  //     const winningSide = point.winningSide;

  //     if (!server || !server.player) continue;

  //     const serverPlayerId = server.player;
  //     const serverSide = server.sideNumber;
  //     const losingSide = winningSide === 1 ? 2 : 1;
  //     const returnerSide = serverSide === 1 ? 2 : 1;
  //     // const playerStats = playerStatsMap[serverId];

  //     const servePlayerStats = playerStatsMap[serverPlayerId];
  //     if (!servePlayerStats) continue;

  //     const currentScore = point[`side${winningSide}Score`]; // e.g. point.side1Score
  //     const previousScore = lastScoreBySide[winningSide] ?? 0;
  //     const pointsGained = currentScore - previousScore;

  //     const returnerPlayerId = match.sides?.[returnerSide-1]?.players?.[0]?.participant?._id;
  //     const returnerPlayerStats = isSinglesMatch ? playerStatsMap[returnerPlayerId] : null;

  //     // SIDE STATS CODE START HERE
  //     // Serve Side Stats
  //     sideStats[serverSide].servePointsPlayedCount += 1;
  //     if (winningSide === serverSide) {
  //       sideStats[serverSide].wonServePointsCount += 1;
  //       sideStats[serverSide].wonServePointsValue += pointsGained;
  //     } else {
  //       sideStats[serverSide].lostServePointsCount += 1;
  //       sideStats[serverSide].lostServePointsValue += pointsGained;
  //     }

  //     // Return Side Stats
  //     sideStats[returnerSide].returnPointsPlayedCount += 1;
  //     if (winningSide === returnerSide) {
  //       sideStats[returnerSide].wonReturnPointsCount += 1;
  //       sideStats[returnerSide].wonReturnPointsValue += pointsGained;
  //     } else {
  //       sideStats[returnerSide].lostReturnPointsCount += 1;
  //       sideStats[returnerSide].lostReturnPointsValue += pointsGained;
  //     }


  //     // Double Faults
  //     if (point.winReason === 'DF') {
  //       sideStats[serverSide].lostDoubleFaultsCount += 1;
  //       sideStats[returnerSide].wonDoubleFaultsCount += 1;
  //     }

  //     // Only process if gained exactly 2
  //     if (pointsGained === 2) {
  //       // Base tracking
  //       sideStats[winningSide].wonTwoPointPlaysCount += 1;
  //       sideStats[winningSide].wonTwoPointPlaysValue += pointsGained;
  //       sideStats[losingSide].lostTwoPointPlaysCount += 1;
  //       sideStats[losingSide].lostTwoPointPlaysValue += pointsGained;

  //       // Serve or return context
  //       if (serverSide === winningSide) {
  //         // Won while serving
  //         sideStats[winningSide].wonTwoPointServeCount += 1;
  //         sideStats[winningSide].wonTwoPointServeValue += pointsGained;

  //         sideStats[losingSide].lostTwoPointReturnCount += 1;
  //         sideStats[losingSide].lostTwoPointReturnValue += pointsGained;
  //       } else {
  //         // Won while returning
  //         sideStats[winningSide].wonTwoPointReturnCount += 1;
  //         sideStats[winningSide].wonTwoPointReturnValue += pointsGained;

  //         sideStats[losingSide].lostTwoPointServeCount += 1;
  //         sideStats[losingSide].lostTwoPointServeValue += pointsGained;
  //       }
  //     }

  //     //Winning Streak Update
  //     sideStats[winningSide].currentWinningStreak += 1;
  //     sideStats[winningSide].maxWinningStreak = Math.max(
  //       sideStats[winningSide].maxWinningStreak,
  //       sideStats[winningSide].currentWinningStreak
  //     );

  //     // reset opponent's win streak
  //     sideStats[losingSide].currentWinningStreak = 0;

  //     //Losing Streak Update
  //     sideStats[losingSide].currentLosingStreak += 1;
  //     sideStats[losingSide].maxLosingStreak = Math.max(
  //       sideStats[losingSide].maxLosingStreak,
  //       sideStats[losingSide].currentLosingStreak
  //     );

  //     // SIDE STATS CODE END HERE
  //     if (servePlayerStats) {
  //       servePlayerStats.stats.servePointsPlayedCount += 1;

  //       if (winningSide === serverSide) {
  //         servePlayerStats.stats.wonServePointsCount += 1;
  //         servePlayerStats.stats.wonServePointsValue += pointsGained;
  //       } else {
  //         servePlayerStats.stats.lostServePointsCount += 1;
  //         servePlayerStats.stats.lostServePointsValue += pointsGained;
  //       }
  //     }

  //     if (isSinglesMatch && returnerPlayerStats) {
  //       returnerPlayerStats.stats.returnPointsPlayedCount += 1;

  //       if (winningSide === returnerSide) {
  //         returnerPlayerStats.stats.wonReturnPointsCount += 1;
  //         returnerPlayerStats.stats.wonReturnPointsValue += pointsGained;
  //       }
  //     }

  //     // DOUBLE FAULTS
  //     if (point.winReason === 'DF') {
  //       if (servePlayerStats) {
  //         servePlayerStats.stats.lostDoubleFaultsCount += 1;
  //       }

  //       if (isSinglesMatch && returnerPlayerStats) {
  //         returnerPlayerStats.stats.wonDoubleFaultsCount += 1;
  //       }
  //     }


  //     if (pointsGained === 2) {
  //       //Server wins 2-point play
  //       if (serverSide === winningSide && servePlayerStats) {
  //         servePlayerStats.stats.wonTwoPointPlaysCount += 1;
  //         servePlayerStats.stats.wonTwoPointPlaysValue += pointsGained;
  //       }

  //       //Server loses 2-point play (whether singles or doubles)
  //       if (serverSide !== winningSide && servePlayerStats) {
  //         servePlayerStats.stats.lostTwoPointPlaysCount += 1;
  //         servePlayerStats.stats.lostTwoPointPlaysValue += pointsGained;
  //       }

  //       //Returner wins 2-point play (singles only)
  //       if (isSinglesMatch && returnerSide === winningSide && returnerPlayerStats) {
  //         returnerPlayerStats.stats.wonReturnTwoPointPlaysCount += 1;
  //         returnerPlayerStats.stats.wonReturnTwoPointPlaysValue += pointsGained;
  //       }

  //       //Returner loses 2-point play (singles only)
  //       if (isSinglesMatch && returnerSide !== winningSide && returnerPlayerStats) {
  //         returnerPlayerStats.stats.lostReturnTwoPointPlaysCount += 1;
  //         returnerPlayerStats.stats.lostReturnTwoPointPlaysValue += pointsGained;
  //       }
  //     }

  //     const pointTime = new Date(point.startPointTimeStamp || point.timestamp);
  //     for (const [playerId, player] of Object.entries(playerStatsMap) as [string, any][]) {
  //       const { sideNumber, appearances, stats } = player;

  //       const isActive = appearances.some(app => {
  //         const inTime = new Date(app.inTime);
  //         const outTime = app.outTime ? new Date(app.outTime) : null;
  //         return pointTime >= inTime && (!outTime || pointTime <= outTime);
  //       });

  //       const currentScore = point[`side${sideNumber}Score`];
  //       const prevScore = lastScoreBySideForPlayerStreak[sideNumber] ?? 0;
  //       const pointsGained = currentScore - prevScore;

  //       const opponentSide = sideNumber === 1 ? 2 : 1;
  //       const opponentCurrent = point[`side${opponentSide}Score`];
  //       const opponentPrev = lastScoreBySideForPlayerStreak[opponentSide] ?? 0;
  //       const pointsLost = opponentCurrent - opponentPrev;

  //       const isWinner = sideNumber === winningSide;

  //       if (servePlayerStats && playerId === serverPlayerId) {
  //         if (serverSide === point.winningSide) {
  //           servePlayerStats.stats.currentWinningStreakCount += 1;
  //           servePlayerStats.stats.maxWinningStreakCount = Math.max(
  //             servePlayerStats.stats.maxWinningStreakCount,
  //             servePlayerStats.stats.currentWinningStreakCount
  //           );

  //           if (pointsGained > 0) {
  //             servePlayerStats.stats.currentWinningStreakValue += pointsGained;
  //             servePlayerStats.stats.maxWinningStreakValue = Math.max(
  //               servePlayerStats.stats.maxWinningStreakValue,
  //               servePlayerStats.stats.currentWinningStreakValue
  //             );
  //           }

  //           // Reset losing streak
  //           servePlayerStats.stats.currentLosingStreakCount = 0;
  //           servePlayerStats.stats.currentLosingStreakValue = 0;
  //           lastScoreBySideForPlayerStreak[sideNumber] = currentScore;
  //         } else {
  //           servePlayerStats.stats.currentWinningStreakCount = 0;
  //           servePlayerStats.stats.currentWinningStreakValue = 0;
  //         }
  //       }

  //       // Losing streak for returner (only if singles)
  //       if (isSinglesMatch && returnerPlayerStats) {
  //         if (returnerSide !== point.winningSide) {
  //           returnerPlayerStats.stats.currentLosingStreakCount += 1;
  //           returnerPlayerStats.stats.maxLosingStreakCount = Math.max(
  //             returnerPlayerStats.stats.maxLosingStreakCount,
  //             returnerPlayerStats.stats.currentLosingStreakCount
  //           );

  //           if (pointsLost > 0) {
  //             returnerPlayerStats.stats.currentLosingStreakValue += pointsLost;
  //             returnerPlayerStats.stats.maxLosingStreakValue = Math.max(
  //               returnerPlayerStats.stats.maxLosingStreakValue,
  //               returnerPlayerStats.stats.currentLosingStreakValue
  //             );
  //           }

  //           // Reset winning streak
  //           returnerPlayerStats.stats.currentWinningStreakCount = 0;
  //           returnerPlayerStats.stats.currentWinningStreakValue = 0;
  //         } else {
  //           returnerPlayerStats.stats.currentLosingStreakCount = 0;
  //           returnerPlayerStats.stats.currentLosingStreakValue = 0;
  //         }
  //       }


  //       if (!isActive) continue;

  //       // Count-based
  //       if (sideNumber === winningSide) {
  //         stats.plusMinusCount += 1;
  //       } else {
  //         stats.plusMinusCount -= 1;
  //       }

  //       // Value-based    
  //       const valueGained = currentScore - prevScore;

  //       if (valueGained > 0) {
  //         if (sideNumber === winningSide) {
  //           stats.plusMinusValue += valueGained;
  //         } else {
  //           stats.plusMinusValue -= valueGained;
  //         }
  //       }

  //       lastScoreBySideForPlusMinus[sideNumber] = currentScore;      

  //     }

  //     // PLAYER STATS CODE START HERE

  //     lastScoreBySide[winningSide] = currentScore;

  //   }
  //   this.calculateTimeOnCourt(match, playerStatsMap, allPoints)   
  // }
  // Top-level entry point
  calculateServeStats(match, playerStatsMap) {
    if (!match.sets || !Array.isArray(match.sets)) return;

    const allPoints = match.sets.flatMap(set => set.games?.[0]?.points || []);

    const sideStats = this.initializeSideStats();
    const isSinglesMatch = match.sides?.[0]?.players?.length === 1 && match.sides?.[1]?.players?.length === 1;

    const lastScoreBySide = { 1: null, 2: null };
    const lastScoreBySideForPlayerStreak = { 1: 0, 2: 0 };
    const lastScoreBySideForPlusMinus = { 1: 0, 2: 0 };

    if (match.matchStatus === "IN_PROGRESS" && allPoints.length > 0) {
      allPoints.pop();
    }

    for (let i = 0; i < allPoints.length; i++) {
      const point = allPoints[i];
      this.processPoint(
        point,
        match,
        sideStats,
        playerStatsMap,
        isSinglesMatch,
        lastScoreBySide,
        lastScoreBySideForPlayerStreak,
        lastScoreBySideForPlusMinus
      );
    }

  this.calculateTimeOnCourt(match, playerStatsMap, allPoints);
}

  initializeSideStats() {
    return {
      1: this.initializeSingleSideStats(),
      2: this.initializeSingleSideStats()
    };
  }

  initializeSingleSideStats() {
    return {
      servePointsPlayedCount: 0,
      wonServePointsCount: 0,
      lostServePointsCount: 0,
      wonServePointsValue: 0,
      lostServePointsValue: 0,
      returnPointsPlayedCount: 0,
      wonReturnPointsCount: 0,
      lostReturnPointsCount: 0,
      wonReturnPointsValue: 0,
      lostReturnPointsValue: 0,
      lostDoubleFaultsCount: 0,
      wonDoubleFaultsCount: 0,
      wonTwoPointPlaysCount: 0,
      wonTwoPointPlaysValue: 0,
      lostTwoPointPlaysCount: 0,
      lostTwoPointPlaysValue: 0,
      wonTwoPointServeCount: 0,
      wonTwoPointServeValue: 0,
      wonTwoPointReturnCount: 0,
      wonTwoPointReturnValue: 0,
      lostTwoPointServeCount: 0,
      lostTwoPointServeValue: 0,
      lostTwoPointReturnCount: 0,
      lostTwoPointReturnValue: 0,
      currentLosingStreak: 0,
      maxLosingStreak: 0,
      currentWinningStreak: 0,
      maxWinningStreak: 0
    };
  }

  processPoint(
    point,
    match,
    sideStats,
    playerStatsMap,
    isSinglesMatch,
    lastScoreBySide,
    lastScoreBySideForPlayerStreak,
    lastScoreBySideForPlusMinus
  ) {
    const server = point.server;
    const winningSide = point.winningSide;

    if (!server || !server.player || !winningSide) return;

    const serverPlayerId = server.player;
    const serverSide = server.sideNumber;
    const returnerSide = serverSide === 1 ? 2 : 1;
    const losingSide = winningSide === 1 ? 2 : 1;
    const servePlayerStats = playerStatsMap[serverPlayerId];
    if (!servePlayerStats) return;

    const currentScore = point[`side${winningSide}Score`];
    const previousScore = lastScoreBySide[winningSide] ?? 0;
    const pointsGained = currentScore - previousScore;

    const returnerPlayerId = match.sides?.[returnerSide - 1]?.players?.[0]?.participant?._id;
    const returnerPlayerStats = isSinglesMatch ? playerStatsMap[returnerPlayerId] : null;

    this.updateTeamServeReturnStats(point, sideStats, serverSide, returnerSide, winningSide, pointsGained);
    this.updateDoubleFaultStats(point, sideStats, serverSide, returnerSide, servePlayerStats, returnerPlayerStats, isSinglesMatch);
    this.updateTwoPointStats(point, sideStats, servePlayerStats, returnerPlayerStats, isSinglesMatch, serverSide, returnerSide, winningSide, pointsGained);
    this.updateStreakStats(sideStats, winningSide, losingSide);
    this.updatePlayerStreaks(point, servePlayerStats, returnerPlayerStats, playerStatsMap, lastScoreBySideForPlayerStreak, isSinglesMatch, serverPlayerId);
    this.updatePlusMinusStats(point, playerStatsMap, lastScoreBySideForPlusMinus, winningSide);

    lastScoreBySide[winningSide] = currentScore;
  }

  updateTeamServeReturnStats(point, sideStats, serverSide, returnerSide, winningSide, pointsGained) {
    sideStats[serverSide].servePointsPlayedCount += 1;
    if (serverSide === winningSide) {
      sideStats[serverSide].wonServePointsCount += 1;
      sideStats[serverSide].wonServePointsValue += pointsGained;
    } else {
      sideStats[serverSide].lostServePointsCount += 1;
      sideStats[serverSide].lostServePointsValue += pointsGained;
    }

    sideStats[returnerSide].returnPointsPlayedCount += 1;
    if (returnerSide === winningSide) {
      sideStats[returnerSide].wonReturnPointsCount += 1;
      sideStats[returnerSide].wonReturnPointsValue += pointsGained;
    } else {
      sideStats[returnerSide].lostReturnPointsCount += 1;
      sideStats[returnerSide].lostReturnPointsValue += pointsGained;
    }
  }

  updateDoubleFaultStats(point, sideStats, serverSide, returnerSide, servePlayerStats, returnerPlayerStats, isSinglesMatch) {
    if (point.winReason === 'DF') {
      sideStats[serverSide].lostDoubleFaultsCount += 1;
      sideStats[returnerSide].wonDoubleFaultsCount += 1;
      if (servePlayerStats) servePlayerStats.stats.lostDoubleFaultsCount += 1;
      if (isSinglesMatch && returnerPlayerStats) returnerPlayerStats.stats.wonDoubleFaultsCount += 1;
    }
  }

  updateTwoPointStats(point, sideStats, servePlayerStats, returnerPlayerStats, isSinglesMatch, serverSide, returnerSide, winningSide, pointsGained) {
    if (pointsGained !== 2) return;

    const losingSide = winningSide === 1 ? 2 : 1;

    sideStats[winningSide].wonTwoPointPlaysCount += 1;
    sideStats[winningSide].wonTwoPointPlaysValue += pointsGained;
    sideStats[losingSide].lostTwoPointPlaysCount += 1;
    sideStats[losingSide].lostTwoPointPlaysValue += pointsGained;

    if (serverSide === winningSide) {
      sideStats[winningSide].wonTwoPointServeCount += 1;
      sideStats[winningSide].wonTwoPointServeValue += pointsGained;
      sideStats[losingSide].lostTwoPointReturnCount += 1;
      sideStats[losingSide].lostTwoPointReturnValue += pointsGained;
      if (servePlayerStats) {
        servePlayerStats.stats.wonTwoPointPlaysCount += 1;
        servePlayerStats.stats.wonTwoPointPlaysValue += pointsGained;
      }
    } else {
      sideStats[winningSide].wonTwoPointReturnCount += 1;
      sideStats[winningSide].wonTwoPointReturnValue += pointsGained;
      sideStats[losingSide].lostTwoPointServeCount += 1;
      sideStats[losingSide].lostTwoPointServeValue += pointsGained;
      if (servePlayerStats) {
        servePlayerStats.stats.lostTwoPointPlaysCount += 1;
        servePlayerStats.stats.lostTwoPointPlaysValue += pointsGained;
      }
      if (isSinglesMatch && returnerPlayerStats) {
        if (returnerSide === winningSide) {
          returnerPlayerStats.stats.wonReturnTwoPointPlaysCount += 1;
          returnerPlayerStats.stats.wonReturnTwoPointPlaysValue += pointsGained;
        } else {
          returnerPlayerStats.stats.lostReturnTwoPointPlaysCount += 1;
          returnerPlayerStats.stats.lostReturnTwoPointPlaysValue += pointsGained;
        }
      }
    }
  }

  updateStreakStats(sideStats, winningSide, losingSide) {
    sideStats[winningSide].currentWinningStreak += 1;
    sideStats[winningSide].maxWinningStreak = Math.max(
      sideStats[winningSide].maxWinningStreak,
      sideStats[winningSide].currentWinningStreak
    );
    sideStats[losingSide].currentWinningStreak = 0;

    sideStats[losingSide].currentLosingStreak += 1;
    sideStats[losingSide].maxLosingStreak = Math.max(
      sideStats[losingSide].maxLosingStreak,
      sideStats[losingSide].currentLosingStreak
    );
  }

  updatePlayerStreaks(point, servePlayerStats, returnerPlayerStats, playerStatsMap, lastScoreBySideForPlayerStreak, isSinglesMatch, serverPlayerId) {
    const pointTime = new Date(point.startPointTimeStamp || point.timestamp);
    const winningSide = point.winningSide;
    const serverSide = point.server.sideNumber;

    for (const [playerId, player] of Object.entries(playerStatsMap) as [string, any][]) {
      const { sideNumber, appearances, stats } = player;

      const isActive = appearances.some(app => {
        const inTime = new Date(app.inTime);
        const outTime = app.outTime ? new Date(app.outTime) : null;
        return pointTime >= inTime && (!outTime || pointTime <= outTime);
      });

      if (!isActive) continue;

      const currentScore = point[`side${sideNumber}Score`];
      const prevScore = lastScoreBySideForPlayerStreak[sideNumber] ?? 0;
      const opponentSide = sideNumber === 1 ? 2 : 1;
      const opponentCurrent = point[`side${opponentSide}Score`];
      const opponentPrev = lastScoreBySideForPlayerStreak[opponentSide] ?? 0;
      const pointsGained = currentScore - prevScore;
      const pointsLost = opponentCurrent - opponentPrev;

      if (playerId === serverPlayerId) {
        if (serverSide === winningSide) {
          stats.currentWinningStreakCount += 1;
          stats.maxWinningStreakCount = Math.max(stats.maxWinningStreakCount, stats.currentWinningStreakCount);

          if (pointsGained > 0) {
            stats.currentWinningStreakValue += pointsGained;
            stats.maxWinningStreakValue = Math.max(stats.maxWinningStreakValue, stats.currentWinningStreakValue);
          }

          stats.currentLosingStreakCount = 0;
          stats.currentLosingStreakValue = 0;
          lastScoreBySideForPlayerStreak[sideNumber] = currentScore;
        } else {
          stats.currentWinningStreakCount = 0;
          stats.currentWinningStreakValue = 0;
        }
      }

      if (isSinglesMatch && returnerPlayerStats && playerId === returnerPlayerStats.playerId) {
        if (point.winningSide !== returnerPlayerStats.sideNumber) {
          stats.currentLosingStreakCount += 1;
          stats.maxLosingStreakCount = Math.max(stats.maxLosingStreakCount, stats.currentLosingStreakCount);

          if (pointsLost > 0) {
            stats.currentLosingStreakValue += pointsLost;
            stats.maxLosingStreakValue = Math.max(stats.maxLosingStreakValue, stats.currentLosingStreakValue);
          }

          stats.currentWinningStreakCount = 0;
          stats.currentWinningStreakValue = 0;
        } else {
          stats.currentLosingStreakCount = 0;
          stats.currentLosingStreakValue = 0;
        }
      }
    }
  }

  updatePlusMinusStats(point, playerStatsMap, lastScoreBySideForPlusMinus, winningSide) {
    for (const [playerId, player] of Object.entries(playerStatsMap) as [string, any][]) {
      const { sideNumber, appearances, stats } = player;
      const pointTime = new Date(point.startPointTimeStamp || point.timestamp);

      const isActive = appearances.some(app => {
        const inTime = new Date(app.inTime);
        const outTime = app.outTime ? new Date(app.outTime) : null;
        return pointTime >= inTime && (!outTime || pointTime <= outTime);
      });

      if (!isActive) continue;

      if (sideNumber === winningSide) {
        stats.plusMinusCount += 1;
      } else {
        stats.plusMinusCount -= 1;
      }

      const currentScore = point[`side${sideNumber}Score`];
      const previousScore = lastScoreBySideForPlusMinus[sideNumber] ?? 0;
      const valueGained = currentScore - previousScore;

      if (valueGained > 0) {
        if (sideNumber === winningSide) {
          stats.plusMinusValue += valueGained;
        } else {
          stats.plusMinusValue -= valueGained;
        }
      }

      lastScoreBySideForPlusMinus[sideNumber] = currentScore;
    }
  }


  calculateTimeOnCourt(match, playerStatsMap, allPoints) {
    const lastPoint = allPoints[allPoints.length - 1];
    const fallbackTime = lastPoint?.timestamp ? new Date(lastPoint.timestamp) : new Date();

    const allLogs = [
      ...(match.playerCourtTimeLog?.side1 || []),
      ...(match.playerCourtTimeLog?.side2 || [])
    ];

    for (const log of allLogs) {
      const playerId = log.player?._id;
      if (!playerId || !playerStatsMap[playerId]) continue;

      const inTime: any = new Date(log.inTime);
      const outTime: any = log.outTime ? new Date(log.outTime) : fallbackTime;

      const durationMs = outTime - inTime;
      if (!isNaN(durationMs) && durationMs > 0) {
        playerStatsMap[playerId].totalCourtTimeInMilliSeconds += durationMs;
        playerStatsMap[playerId].totalCourtTimeInMinutesHour = durationMs / 60000;
      }
    }
  }

  async toggleScoringOnTieBreakGameFormate(match: Match) {
    try {
      let isTiebreak = this.bhs.getLastGame(match).gameFormat === GameFormat.TIEBREAK? true : false;
      const currentScoringType = this.getCurrentScoringType(match, isTiebreak);
      this.matchService.autoSwitchScoringTypeOnTieBreak({currentScoringType: currentScoringType, matchId: match._id});
    } catch(error) {
      this.toastService.presentDangerToast('An error occurred while updating the scoring type.');
    }
    
  }

  getCurrentScoringType(match: Match, isTiebreak: boolean) {
    if (this.trackerSelectedScoringType) {
      return this.trackerSelectedScoringType;
    }
    const lastSet = this.bhs.getLastSet(this.match);
    const lastGame = this.bhs.getLastGame(this.match);
    const wasPointByPoint = lastSet?.previousScoringType === "pointByPoint"?true: false;
    const currentScoringType = (isTiebreak || wasPointByPoint)? "pointByPoint": "gameByGame";
    return currentScoringType;
  }

  getPreviousScoringType(lastSet: Set) {
    return lastSet?.previousScoringType == "pointByPoint" ? "pointByPoint" : "gameByGame";
  }

  subscribeTrackerChangedScoringType() {
    this.scoringTypeSubscription =  this.matchService.subscribeTrackerChangedScoringType().pipe(
      takeUntil(this.destroy$)
    ).subscribe((data: any) => {
      if(data.matchId === this.match._id) { 
        this.bhs.getLastSet(this.match).previousScoringType = data.scoringType;
        this.trackerSelectedScoringType = data.scoringType;
      }
    });
  }
}
